export default {
  // app
  'pages.app.name': '猎头助手',

  // layouts
  'pages.layouts.userLayout.title': '全球领先的猎头管理平台',
  // ==================== 通用翻译 ====================
  'pages.common.coming.soon': '功能开发中',
  'pages.common.copy.failed': '复制失败',
  'pages.common.copy.success': '复制成功',
  'pages.common.delete': '删除',
  'pages.common.save.success': '保存成功',

  // ==================== 项目基础信息 ====================
  'pages.project.name': '项目名称',
  'pages.project.description': '项目描述',
  'pages.project.status': '项目状态',
  'pages.project.priority': '优先级',
  'pages.project.start.date': '开始日期',
  'pages.project.end.date': '结束日期',
  'pages.project.notes': '备注',

  // ==================== 候选人相关 ====================
  'pages.project.candidate': '候选人',
  'pages.project.candidate.name': '候选人姓名',
  'pages.project.candidate.company': '当前公司',
  'pages.project.candidate.position': '当前职位',
  'pages.project.candidate.salary': '当前薪资',
  'pages.project.candidate.age': '年龄',
  'pages.project.candidate.tags': '标签',
  'pages.project.candidate.stage': '业务阶段',
  'pages.project.candidate.phone': '电话',
  'pages.project.candidate.email': '邮箱',
  'pages.project.candidate.score': '评分',
  'pages.project.candidate.updated.at': '更新时间',
  'pages.project.candidate.notes': '备注',
  'pages.project.candidate.priority': '优先级',
  'pages.project.candidate.risk': '风险等级',

  // ==================== 候选人操作 ====================
  'pages.project.add': '添加',
  'pages.project.add.note': '添加备注',
  'pages.project.add.action': '添加行动',
  'pages.project.add.candidate.success': '添加候选人成功',
  'pages.project.add.candidate.failed': '添加候选人失败',
  'pages.project.select.candidate.first': '请先选择候选人',
  'pages.project.select.candidates.first': '请先选择候选人',

  // ==================== 候选人阶段 ====================
  'pages.project.stage.offer_signed': '签订Offer',
  'pages.project.stage.onboarded': '已入职',

  // ==================== 风险识别 ====================
  'pages.project.risk.high': '高风险',
  'pages.project.risk.medium': '中风险',
  'pages.project.risk.low': '低风险',
  'pages.project.risk.no.feedback': '缺少客户反馈',

  // ==================== 优先级设置 ====================
  'pages.project.priority.set.success': '优先级设置成功',

  // ==================== 推荐给客户 ====================
  'pages.project.recommend.date': '推荐日期',
  'pages.project.recommend.channel': '推荐渠道',
  'pages.project.channel.email': '邮件',
  'pages.project.channel.phone': '电话',
  'pages.project.channel.wechat': '微信',
  'pages.project.channel.meeting': '会议',
  'pages.project.client.contact': '客户联系人',

  // ==================== 面试管理 ====================
  'pages.project.interview.candidate': '候选人',
  'pages.project.interview.round': '面试轮次',
  'pages.project.interview.round.prefix': '第',
  'pages.project.interview.round.suffix': '轮',
  'pages.project.interview.type': '面试方式',
  'pages.project.interview.datetime': '面试时间',
  'pages.project.interview.location': '面试地点',
  'pages.project.interview.status': '面试状态',
  'pages.project.interview.result': '面试结果',
  'pages.project.interview.score': '面试评分',
  'pages.project.score.unit': '分',

  // ==================== 客户反馈 ====================
  'pages.project.client.feedback': '客户反馈',
  'pages.project.feedback.content': '反馈内容',
  'pages.project.detail.feedback.success': '反馈记录成功',

  // ==================== Offer管理 ====================
  'pages.project.offer.status': 'Offer状态',
  'pages.project.offer.sent': 'Offer已发放',
  'pages.project.offer.accepted': 'Offer已接受',
  'pages.project.offer.rejected': 'Offer已拒绝',
  'pages.project.offer.confirm.date': '确认日期',
  'pages.project.offer.annual.salary': '年薪',
  'pages.project.offer.fee.amount': '服务费',
  'pages.project.offer.add.item': '添加薪资项',

  // ==================== 入职管理 ====================
  'pages.project.join.date': '入职日期',
  'pages.project.onboard.status': '入职状态',
  'pages.project.probation.end.date': '试用期结束日期',
  'pages.project.probation.passed': '试用期通过',
  'pages.project.probation.failed': '试用期未通过',
  'pages.project.remind.target': '提醒对象',

  // ==================== 背调管理 ====================
  'pages.project.background.check': '背景调查',
  'pages.project.bgcheck.date': '背调日期',
  'pages.project.bgcheck.status': '背调状态',
  'pages.project.bgcheck.result': '背调结果',
  'pages.project.bgcheck.completed': '背调完成',
  'pages.project.bgcheck.failed': '背调失败',
  'pages.project.bgcheck.passed': '背调通过',
  'pages.project.bgcheck.pending': '背调进行中',
  'pages.project.bgcheck.success': '背调信息提交成功',

  // ==================== 下一步行动 ====================
  'pages.project.next.action': '下一步行动',
  'pages.project.action.content': '行动内容',
  'pages.project.action.owner': '负责人',
  'pages.project.next.action.saved': '下一步行动已保存',
  'pages.project.next.action.save.failed': '保存下一步行动失败',

  // ==================== 状态历史 ====================
  'pages.project.status.history': '状态历史',
  'pages.project.view.history': '查看历史',
  'pages.project.no.history': '暂无历史记录',

  // ==================== AI推荐 ====================
  'pages.project.ai.recommendation': 'AI推荐候选人',
  'pages.project.match.score': '匹配度',
  'pages.project.match.reasons': '匹配原因',
  'pages.project.min.match.score': '最低匹配度',

  // ==================== 批量操作 ====================
  'pages.project.batch.update.success': '批量更新成功',
  'pages.project.batch.update.failed': '批量更新失败',

  // ==================== 导出功能 ====================
  'pages.project.export.loading': '正在加载数据...',
  'pages.project.export.no.data': '没有可导出的数据',
  'pages.project.export.success': '导出成功',
  'pages.project.export.failed': '导出失败',

  // ==================== 数据验证 ====================
  'pages.project.validate.name.required': '候选人姓名不能为空',
  'pages.project.validate.talent.required': '必须关联人才信息',
  'pages.project.validate.status.required': '状态不能为空',

  // ==================== 错误处理 ====================
  'pages.project.error.not.found': '项目不存在',
  'pages.project.error.no.permission': '没有访问权限',
  'pages.project.error.server.error': '服务器错误，请稍后重试',
  'pages.project.error.unknown': '未知错误',
  'pages.project.detail.load.talent.failed': '加载人才详情失败',

  // navigation
  'pages.navigation': '猎头助手',
  // menu
  'pages.menu.title': '猎头助手',
  'pages.menu.collapse': '收起',
  'pages.menu.expand': '展开',
  'pages.menu.dashboard': '仪表盘',
  'pages.menu.jobs': '职位',
  'pages.menu.jobs.all': '全部职位',
  'pages.menu.jobs.my': '我创建的职位',
  'pages.menu.talents': '人才',
  'pages.menu.talents.all': '全部人才',
  'pages.menu.talents.my': '我创建的人才',
  'pages.menu.talents.private': '我私池的人才',
  'pages.menu.talents.public': '公海人才',
  'pages.menu.talents.collections': '人才收藏夹',
  'pages.menu.clients': '客户',
  'pages.menu.clients.all': '全部客户',
  'pages.menu.clients.my': '我创建的客户',
  'pages.menu.clients.myClients': '我的客户',
  'pages.menu.clients.private': '我私池的客户',
  'pages.menu.clients.privateClients': '我的私池客户',
  'pages.menu.clients.public': '公海客户',
  'pages.menu.clients.publicClients': '公海客户',
  'pages.menu.clients.collections': '客户收藏夹',
  'pages.menu.clients.clientCollection': '客户收藏夹',
  'pages.menu.projects.collections': '项目收藏夹',
  'pages.menu.projects': '项目',
  'pages.menu.projects.all': '全部项目',
  'pages.menu.projects.my': '我创建的项目',
  'pages.menu.projects.recommended': '我推荐的项目',
  'pages.menu.projects.responsible': '我负责的项目',
  'pages.menu.projects.interviews': '面试管理',
  'pages.menu.projects.interviews.phone': '电话面试',
  'pages.menu.projects.interviews.video': '视频面试',
  'pages.menu.projects.interviews.face.to.face': '面对面面试',
  'pages.menu.interviews': '面试',
  'pages.menu.interviews.phone': '电话面试',
  'pages.menu.interviews.video': '视频面试',
  'pages.menu.interviews.face.to.face': '面对面面试',

  // interviews
  'pages.interviews.column.talent.name': '候选人姓名',
  'pages.interviews.column.round': '面试轮次',
  'pages.interviews.column.type': '面试类型',
  'pages.interviews.column.scheduled.date': '面试时间',
  'pages.interviews.column.location': '面试地点',
  'pages.interviews.column.status': '面试状态',

  'pages.menu.questions': '问师傅',
  'pages.menu.questions.all': '全部问题',
  'pages.menu.questions.my': '我创建的问题',
  'pages.menu.questions.my.answers': '我的回答',
  'pages.menu.questions.categories': '分类管理',
  'pages.menu.analytics': '数据分析',
  'pages.menu.analytics.overview': '数据概览',
  'pages.menu.analytics.jobs': '职位分析',
  'pages.menu.analytics.talents': '人才分析',
  'pages.menu.analytics.clients': '客户分析',
  'pages.menu.analytics.projects': '项目分析',
  'pages.menu.analytics.work': '工作分析',
  'pages.menu.daily.reports': '日报',
  'pages.menu.daily.reports.today': '今日日报',
  'pages.menu.daily.reports.all': '全部日报',
  'pages.menu.weekly.reports': '周报',
  'pages.menu.weekly.reports.this.week': '本周周报',
  'pages.menu.weekly.reports.all': '全部周报',
  'pages.menu.monthly.reports': '月报',
  'pages.menu.monthly.reports.this.month': '本月月报',
  'pages.menu.monthly.reports.all': '全部月报',
  'pages.menu.yearly.reports': '年报',
  'pages.menu.yearly.reports.this.year': '本年年报',
  'pages.menu.yearly.reports.all': '全部年报',
  'pages.menu.personal.settings': '个人设置',
  'pages.menu.personal.settings.main': '基础信息',
  'pages.menu.personal.settings.messages': '消息中心',
  'pages.menu.personal.settings.report.templates': '推荐报告模板',
  'pages.menu.data.dictionaries': '数据字典',
  'pages.menu.dataDictionaries': '数据字典',

  // common
  'pages.common.of': '共',
  'pages.common.loading': '加载中...',
  'pages.common.all': '全部',
  'pages.common.view.details': '查看详情',
  'pages.common.back': '返回',
  'pages.common.edit': '编辑',
  'pages.common.view': '查看',
  'pages.common.actions': '操作',
  'pages.common.total': '共',
  'pages.common.export': '导出',
  'pages.common.comments': '评论',
  'pages.common.remarks': '备注',
  'pages.common.messages': '消息',
  'pages.common.search': '搜索',
  'pages.common.search.placeholder': '多关键字用空格隔开',
  'pages.common.clear': '清空',
  'pages.common.default': '默认',
  'pages.common.results': '条结果',
  'pages.common.status.active': '活跃',
  'pages.common.status.inactive': '非活跃',
  'pages.common.status.contacted': '已联系',
  'pages.common.status.interviewed': '已面试',
  'pages.common.failed': '个失败',
  'pages.common.confirm': '确认',
  'pages.common.cancel': '取消',
  'pages.common.components.priority.high': '高',
  'pages.common.components.priority.medium': '中',
  'pages.common.components.priority.low': '低',
  'pages.common.components.salary.current.label': '现',
  'pages.common.components.salary.expected.label': '期',
  'pages.common.components.experience.years': '{years}年经验',
  'pages.common.unknown': '未知',
  'pages.common.not.provided': '暂无数据',
  'pages.common.minutes': '分钟',
  'pages.common.notes': '备注',
  'pages.common.notes.placeholder': '请输入备注',
  'pages.common.copy': '复制',
  'pages.common.save': '保存',
  'pages.common.send': '发送',

  // operation
  'pages.operation.logs.title': '操作记录',
  'pages.operation.logs.load.failed': '获取操作记录失败',
  'pages.operation.logs.filter.type.placeholder': '操作类型',
  'pages.operation.logs.search.placeholder': '搜索操作描述或操作人',
  'pages.operation.logs.empty': '暂无操作记录',
  'pages.operation.logs.operator.system': '系统',
  'pages.operation.logs.total': '共 {total} 条记录',
  'pages.operation.logs.type.create': '创建',
  'pages.operation.logs.type.update': '更新',
  'pages.operation.logs.type.delete': '删除',
  'pages.operation.logs.type.status.change': '状态变更',
  'pages.operation.logs.type.associate': '关联',
  'pages.operation.logs.type.disassociate': '取消关联',
  'pages.operation.logs.value.empty': '空',
  'pages.operation.logs.value.boolean.true': '是',
  'pages.operation.logs.value.boolean.false': '否',

  // dashboard
  'pages.dashboard': '首页',
  'pages.dashboard.title': '猎头工作台',
  'pages.dashboard.subtitle': '集中掌握候选人、职位、客户与项目的实时进度。',
  'pages.dashboard.total.talents': '总人才数',
  'pages.dashboard.active.jobs': '进行中职位',
  'pages.dashboard.total.clients': '总客户数',
  'pages.dashboard.active.projects': '进行中项目',
  'pages.dashboard.success.rate.trend': '推荐成功率趋势',
  'pages.dashboard.project.status': '项目状态分布',
  'pages.dashboard.view.details': '查看详情',
  'pages.dashboard.monthly.target': '月度目标进度',
  'pages.dashboard.talent.target': '人才推荐目标',
  'pages.dashboard.project.target': '项目交付目标',
  'pages.dashboard.revenue.target': '营收目标',
  'pages.dashboard.recent.activities': '最新动态',
  'pages.dashboard.view.all': '查看全部',
  'pages.dashboard.activity': '动态类型',
  'pages.dashboard.name': '名称',
  'pages.dashboard.time': '时间',
  'pages.dashboard.status': '状态',
  'pages.dashboard.completed': '已完成',
  'pages.dashboard.processing': '处理中',
  'pages.dashboard.pending': '待处理',
  'pages.dashboard.quick.actions': '快捷操作',
  'pages.dashboard.add.talent': '新增人才',
  'pages.dashboard.create.job': '创建职位',
  'pages.dashboard.add.client': '新增客户',
  'pages.dashboard.create.project': '创建项目',
  'pages.dashboard.loading': '仪表盘数据加载中...',
  'pages.dashboard.error': '仪表盘数据加载失败',
  'pages.dashboard.retry': '重试',
  'pages.dashboard.error.network': '网络错误，请检查网络连接后重试。',
  'pages.dashboard.error.server': '服务器错误，请稍后重试。',
  'pages.dashboard.error.unauthorized': '认证失败，请检查登录状态。',
  'pages.dashboard.no.data': '暂无活动记录',
  'pages.dashboard.activity.add.talent': '新增人才',
  'pages.dashboard.activity.project.update': '项目更新',
  'pages.dashboard.activity.schedule.interview': '安排面试',
  'pages.dashboard.activity.send.offer': '发送 Offer',
  'pages.dashboard.activity.candidate.a': '张三 · 高级前端工程师',
  'pages.dashboard.activity.project.a': '前端开发工程师招聘',
  'pages.dashboard.activity.candidate.b': '李四 · 技术面试',
  'pages.dashboard.activity.offer.target': '王五 · 产品经理',
  'pages.dashboard.activity.time.2h': '2 小时前',
  'pages.dashboard.activity.time.4h': '4 小时前',
  'pages.dashboard.activity.time.6h': '6 小时前',
  'pages.dashboard.activity.time.1d': '1 天前',
  'pages.dashboard.quarter.q1': '第一季度',
  'pages.dashboard.quarter.q2': '第二季度',
  'pages.dashboard.quarter.q3': '第三季度',
  'pages.dashboard.quarter.q4': '第四季度',
  'pages.dashboard.project.status.running': '进行中',
  'pages.dashboard.project.status.completed': '已完成',
  'pages.dashboard.project.status.paused': '暂停中',
  'pages.dashboard.project.status.cancelled': '已取消',
  'pages.dashboard.monthly.target.value': '24 / 30',
  'pages.dashboard.project.target.value': '18 / 25',
  'pages.dashboard.revenue.target.value': '¥156K / ¥200K',

  // job
  'pages.job.title': '职位管理',
  'pages.job.subtitle': '统一管理所有职位需求，实时掌握招聘进度。',
  'pages.job.search.placeholder': '搜索职位标题、客户、技能关键词...',
  'pages.job.filter.status': '按状态筛选',
  'pages.job.advanced.search': '高级搜索',
  'pages.job.add.job': '新增职位',
  'pages.job.status.open': '招聘中',
  'pages.job.status.paused': '已暂停',
  'pages.job.status.closed': '已关闭',
  'pages.job.status.completed': '已完成',
  'pages.job.load.failed': '加载职位列表失败，请稍后重试。',
  'pages.job.client.search.failed': '搜索客户失败，请稍后重试。',
  'pages.job.client.search.hint': '请输入关键词搜索客户',
  'pages.job.field.client.invalid.uuid': '请从下拉列表中选择有效的客户',
  'pages.job.create.success': '创建职位成功',
  'pages.job.update.success': '更新职位成功',
  'pages.job.save.failed': '保存职位失败，请稍后重试。',
  'pages.job.ai.write': 'AI帮写',
  'pages.job.ai.write.tooltip': '根据职位标题等信息，生成职位描述',
  'pages.job.ai.write.failed': 'AI生成失败，请稍后重试。',
  'pages.job.ai.complete': '解析描述并补全表单',
  'pages.job.ai.complete.tooltip':
    '解析当前输入的职位描述，自动填充职位标题、行业、薪资、工作年限、地点等所有字段',
  'pages.job.ai.complete.hint':
    '粘贴或输入完整 JD 后点击，自动填充标题、行业、薪资等',
  'pages.job.ai.complete.failed': 'AI补全失败，请稍后重试。',
  'pages.job.ai.complete.required': '请先输入职位描述内容',
  'pages.job.tab.all': '全部',
  'pages.job.items': '条记录',
  'pages.job.total.results': '总共: {total} 条结果',
  'pages.job.no.data': '暂无职位数据',
  'pages.job.modal.edit.title': '编辑职位',
  'pages.job.modal.add.title': '新增职位',
  'pages.job.save': '保存',
  'pages.job.save.and.create.project': '创建职位并创建项目',
  'pages.job.cancel': '取消',
  'pages.job.field.title': '职位标题',
  'pages.job.field.title.required': '请输入职位标题',
  'pages.job.field.title.placeholder': '请输入职位名称',
  'pages.job.field.client': '客户',
  'pages.job.field.client.required': '请选择客户',
  'pages.job.field.client.placeholder': '搜索客户名称',
  'pages.job.field.department': '部门',
  'pages.job.field.department.required': '请输入部门',
  'pages.job.field.department.placeholder': '请输入部门名称',
  'pages.job.field.level': '职级',
  'pages.job.field.level.required': '请选择职级',
  'pages.job.field.level.placeholder': '请选择职级',
  'pages.job.level.junior': '初级',
  'pages.job.level.middle': '中级',
  'pages.job.level.senior': '高级',
  'pages.job.level.expert': '资深',
  'pages.job.field.location': '工作地点',
  'pages.job.field.location.required': '请输入工作地点',
  'pages.job.field.location.placeholder': '请输入工作地点',
  'pages.job.field.industry': '行业',
  'pages.job.field.industry.required': '请选择行业',
  'pages.job.field.industry.placeholder': '请选择行业',
  'pages.job.industry.internet': '互联网',
  'pages.job.industry.finance': '金融',
  'pages.job.industry.ecommerce': '电商',
  'pages.job.industry.education': '教育',
  'pages.job.industry.construction': '建筑/建设',
  'pages.job.field.function': '职能',
  'pages.job.field.function.required': '请选择职能',
  'pages.job.field.function.placeholder': '请选择职能',
  'pages.job.function.tech': '技术',
  'pages.job.function.product': '产品',
  'pages.job.function.operation': '运营',
  'pages.job.function.sales': '销售',
  'pages.job.field.status': '状态',
  'pages.job.field.status.required': '请选择状态',
  'pages.job.field.status.placeholder': '请选择状态',
  'pages.job.field.priority': '优先级',
  'pages.job.field.priority.required': '请选择优先级',
  'pages.job.field.priority.placeholder': '请选择优先级',
  'pages.job.priority.high': '高',
  'pages.job.priority.medium': '中',
  'pages.job.priority.low': '低',
  'pages.job.field.deadline': '截止日期',
  'pages.job.field.deadline.required': '请选择截止日期',
  'pages.job.field.deadline.placeholder': '请选择日期',
  'pages.job.field.salary.range': '年薪范围',
  'pages.job.field.salary.range.required': '请输入年薪范围',
  'pages.job.field.salary.range.placeholder': '请输入年薪范围',
  'pages.job.field.salary.min': '最低年薪（万）',
  'pages.job.field.salary.min.required': '请输入最低年薪',
  'pages.job.field.salary.min.placeholder': '请输入最低年薪（万）',
  'pages.job.field.salary.max': '最高年薪（万）',
  'pages.job.field.salary.max.required': '请输入最高年薪',
  'pages.job.field.salary.max.placeholder': '请输入最高年薪（万）',
  'pages.job.field.famous.company.background': '名企背景',
  'pages.job.field.famous.company.background.placeholder': '请选择名企背景',
  'pages.job.field.nationality': '国籍',
  'pages.job.field.nationality.placeholder': '请选择国籍',
  'pages.job.field.first.degree': '学历要求',
  'pages.job.field.first.degree.placeholder': '请选择学历要求',
  'pages.job.field.language.proficiency': '语言能力',
  'pages.job.field.language.proficiency.placeholder': '请选择语言能力',
  'pages.job.field.age.requirement': '年龄要求',
  'pages.job.field.age.min.placeholder': '最小年龄',
  'pages.job.field.age.max.placeholder': '最大年龄',
  'pages.job.field.work.experience.requirement': '工作年限要求',
  'pages.job.field.work.experience.min.placeholder': '最小年限',
  'pages.job.field.work.experience.max.placeholder': '最大年限',
  'pages.job.field.description': '职位描述',
  'pages.job.field.description.required': '请输入职位描述',
  'pages.job.field.description.placeholder': '请输入详细描述',
  'pages.job.field.requirements': '任职要求',
  'pages.job.field.requirements.required': '请输入任职要求',
  'pages.job.field.requirements.placeholder': '请输入任职要求',
  'pages.job.detail.load.failed': '加载职位详情失败，请稍后重试。',
  'pages.job.detail.not.found': '未找到对应的职位。',
  'pages.job.detail.back': '返回',
  'pages.job.detail.header.subtitle': '关联客户：{company}',
  'pages.job.detail.basic.info.section': '基础信息',
  'pages.job.detail.tab.basic.info': '职位信息',
  'pages.job.detail.created.at': '创建时间',
  'pages.job.detail.updated.at': '更新时间',
  'pages.job.detail.empty.description': '暂无职位描述。',
  'pages.job.detail.empty.requirements': '暂无任职要求。',
  'pages.job.detail.client.section.title': '客户信息',
  'pages.job.detail.client.empty': '暂未关联客户。',
  'pages.job.detail.tab.interviews': '岗位访谈',
  'pages.job.detail.interviews.section.title': '岗位访谈记录',
  'pages.job.field.tags': '标签',
  'pages.job.field.tags.placeholder': '输入标签后回车确认',
  'pages.job.interview.list.load.failed': '加载访谈记录失败',
  'pages.job.interview.delete.success': '删除访谈成功',
  'pages.job.interview.delete.failed': '删除访谈失败',
  'pages.job.interview.delete.confirm': '确定要删除该访谈记录吗？',
  'pages.job.interview.create': '新增访谈',
  'pages.job.interview.create.first': '创建第一条访谈记录',
  'pages.job.interview.empty': '暂无访谈记录',
  'pages.job.interview.edit': '编辑访谈',
  'pages.job.interview.create.success': '访谈创建成功',
  'pages.job.interview.update.success': '访谈更新成功',
  'pages.job.interview.save.failed': '保存访谈失败',
  'pages.job.interview.type': '访谈类型',
  'pages.job.interview.type.required': '请选择访谈类型',
  'pages.job.interview.type.placeholder': '请选择访谈类型',
  'pages.job.interview.type.phone': '电话',
  'pages.job.interview.type.video': '视频',
  'pages.job.interview.type.face.to.face': '面对面',
  'pages.job.interview.type.email': '邮件',
  'pages.job.interview.type.other': '其他',
  'pages.job.interview.scheduled.date': '计划时间',
  'pages.job.interview.scheduled.date.required': '请选择计划时间',
  'pages.job.interview.scheduled.date.placeholder': '选择计划日期时间',
  'pages.job.interview.actual.date': '实际时间',
  'pages.job.interview.actual.date.placeholder': '选择实际日期时间',
  'pages.job.interview.duration': '时长（分钟）',
  'pages.job.interview.duration.required': '请输入时长',
  'pages.job.interview.duration.placeholder': '请输入时长（分钟）',
  'pages.job.interview.location': '地点',
  'pages.job.interview.location.tooltip': '城市/现场地点或会议链接',
  'pages.job.interview.location.placeholder': '请输入地点或会议链接',
  'pages.job.interview.subject': '主题',
  'pages.job.interview.subject.required': '请输入访谈主题',
  'pages.job.interview.subject.placeholder': '请输入访谈主题',
  'pages.job.interview.content': '摘要',
  'pages.job.interview.content.required': '请输入访谈摘要',
  'pages.job.interview.content.placeholder': '输入摘要或关键信息',
  'pages.job.interview.key.points': '关键要点',
  'pages.job.interview.key.points.tooltip': '一行一条，将保存为列表',
  'pages.job.interview.key.points.placeholder': '请输入关键要点，每行一条',
  'pages.job.interview.discussed.salary.range': '讨论的薪资范围',
  'pages.job.interview.discussed.salary.range.placeholder': '如 30k-45k/月',
  'pages.job.interview.result': '结果',
  'pages.job.interview.result.placeholder': '请选择结果',
  'pages.job.interview.result.success': '成功',
  'pages.job.interview.result.postponed': '延期',
  'pages.job.interview.result.cancelled': '取消',
  'pages.job.interview.result.failed': '失败',
  'pages.job.interview.discussed.requirements': '讨论的要求',
  'pages.job.interview.discussed.requirements.placeholder': '填写讨论的要求',
  'pages.job.interview.discussed.responsibilities': '讨论的职责',
  'pages.job.interview.discussed.responsibilities.placeholder':
    '填写讨论的职责',
  'pages.job.interview.discussed.team.info': '讨论的团队信息',
  'pages.job.interview.discussed.team.info.placeholder':
    '团队架构、人数、汇报关系等',
  'pages.job.interview.discussed.company.culture': '讨论的公司文化',
  'pages.job.interview.discussed.company.culture.placeholder':
    '文化、价值观、工作方式等',
  'pages.job.interview.outcome': '结论',
  'pages.job.interview.outcome.required': '请输入访谈结论',
  'pages.job.interview.outcome.placeholder': '请输入决策或结论',
  'pages.job.interview.next.action': '下一步动作',
  'pages.job.interview.next.action.required': '请输入下一步动作',
  'pages.job.interview.next.action.placeholder': '请输入跟进动作',
  'pages.job.interview.next.action.date': '下一步日期',
  'pages.job.interview.next.action.date.placeholder': '选择下一步日期',
  'pages.job.interview.is.important': '标记为重要',
  'pages.job.interview.client.satisfaction': '客户满意度',
  'pages.job.interview.client.satisfaction.placeholder': '1-5分',
  'pages.job.interview.recruiter.rating': '顾问评分',
  'pages.job.interview.recruiter.rating.placeholder': '1-5分',
  'pages.job.action.edit': '编辑',
  'pages.job.column.title': '职位标题',
  'pages.job.column.company': '公司',
  'pages.job.column.level': '职级',
  'pages.job.column.location': '工作地点',
  'pages.job.column.salary': '薪资范围',
  'pages.job.column.priority': '优先级',
  'pages.job.column.status': '状态',
  'pages.job.column.deadline': '截止日期',
  'pages.job.column.actions': '操作',
  'pages.job.advanced.search.title': '高级搜索',
  'pages.job.reset': '重置',
  'pages.job.search': '搜索',
  'pages.job.tab.basic.info': '基本信息',
  'pages.job.tab.interviews': '访谈记录',
  'pages.job.interviews.section.title': '访谈记录',
  'pages.job.basic.info.section': '基本信息',
  'pages.job.created.at': '创建时间',
  'pages.job.updated.at': '更新时间',
  'pages.job.empty.description': '暂无职位描述',
  'pages.job.empty.requirements': '暂无任职要求',
  'pages.job.client.section.title': '客户信息',
  'pages.job.client.empty': '暂未关联客户',

  // talent
  'pages.talent.title': '人才管理',
  'pages.talent.subtitle': '统一管理候选人档案，随时掌握跟进进度。',
  'pages.talent.search.placeholder': '输入关键词，多个关键词用空格分隔...',
  'pages.talent.keyword.match.all': '全部关键词',
  'pages.talent.keyword.match.any': '任意关键词',
  'pages.talent.filter.status': '按状态筛选',
  'pages.talent.advanced.search': '高级搜索',
  'pages.talent.add.talent': '新增人才',
  'pages.talent.items': '条记录',
  'pages.talent.no.data': '暂无人才数据',
  'pages.talent.load.failed': '加载人才列表失败，请稍后重试。',
  'pages.talent.update.success': '人才更新成功',
  'pages.talent.create.success': '人才创建成功',
  'pages.talent.save.failed': '保存人才失败，请稍后重试。',
  'pages.talent.modal.edit.title': '编辑人才',
  'pages.talent.modal.add.title': '新增人才',
  'pages.talent.column.name': '姓名',
  'pages.talent.column.position': '职位',
  'pages.talent.column.company': '公司',
  'pages.talent.column.contact': '联系方式',
  'pages.talent.column.location': '所在城市',
  'pages.talent.column.salary': '薪资（现/期望）',
  'pages.talent.salary.unknown': '未填写',
  'pages.talent.column.status': '状态',
  'pages.talent.column.owner': '负责人',
  'pages.talent.column.updated.at': '更新时间',
  'pages.talent.column.age': '年龄',
  'pages.talent.column.phone': '手机',
  'pages.talent.column.tags': '标签',
  'pages.talent.column.last.contact': '最近联系',
  'pages.talent.column.latest.remark': '最新备注',
  'pages.talent.column.actions': '操作',
  'pages.talent.sort.by.recent.contact': '按最近联系排序',
  'pages.talent.sort.by.created.time': '按创建日期排序',
  'pages.talent.view.table': '表格视图',
  'pages.talent.view.list': '列表视图',
  'pages.talent.column.config': '列设置',
  'pages.talent.column.config.desc': '配置显示的列及其顺序',
  'pages.talent.column.reset': '重置',
  'pages.talent.column.move.up': '上移',
  'pages.talent.column.move.down': '下移',
  'pages.talent.action.edit': '编辑',
  'pages.talent.action.view': '查看',
  'pages.talent.status.all': '全部状态',
  'pages.talent.status.active': '活跃',
  'pages.talent.status.inactive': '非活跃',
  'pages.talent.status.placed': '已入职',
  'pages.talent.status.blacklisted': '黑名单',
  'pages.talent.field.id': 'ID',
  'pages.talent.field.id.placeholder': '请输入人才ID',
  'pages.talent.field.name': '姓名',
  'pages.talent.field.name.required': '请输入姓名',
  'pages.talent.field.name.placeholder': '请输入姓名',
  'pages.talent.field.gender': '性别',
  'pages.talent.field.gender.placeholder': '请选择性别',
  'pages.talent.field.gender.male': '男',
  'pages.talent.field.gender.female': '女',
  'pages.talent.field.phone': '电话',
  'pages.talent.field.phone.placeholder': '请输入联系电话',
  'pages.talent.field.email': '邮箱',
  'pages.talent.field.email.placeholder': '请输入邮箱地址',
  'pages.talent.field.birthdate': '出生日期',
  'pages.talent.field.birthdate.placeholder': '选择出生日期',
  'pages.talent.field.education': '学历',
  'pages.talent.field.education.placeholder': '请选择学历',
  'pages.talent.field.wechat': '微信',
  'pages.talent.field.language': '语言能力',
  'pages.talent.field.language.placeholder': '请输入语言能力',
  'pages.talent.field.hukou': '户口',
  'pages.talent.field.hukou.placeholder': '请输入户口所在地',
  'pages.talent.field.intention.city': '意向城市',
  'pages.talent.field.intention.city.placeholder': '请输入意向城市',
  'pages.talent.field.current.company': '现公司',
  'pages.talent.field.current.company.placeholder': '请输入现公司',
  'pages.talent.field.current.position': '现职位',
  'pages.talent.field.current.position.placeholder': '请输入现职位',
  'pages.talent.field.current.salary': '现薪资',
  'pages.talent.field.current.salary.placeholder': '请输入现薪资',
  'pages.talent.field.current.salary.remark': '薪资备注',
  'pages.talent.field.current.salary.remark.placeholder': '请输入薪资备注',
  'pages.talent.field.expected.salary': '期望薪资',
  'pages.talent.field.expected.salary.placeholder': '请输入期望薪资',
  'pages.talent.field.expected.salary.min': '期望薪资下限',
  'pages.talent.field.expected.salary.max': '期望薪资上限',
  'pages.talent.field.location': '所在城市',
  'pages.talent.field.location.placeholder': '请输入所在城市',
  'pages.talent.field.status': '状态',
  'pages.talent.field.status.placeholder': '请选择状态',
  'pages.talent.field.skills': '技能',
  'pages.talent.field.skills.placeholder': '输入技能后回车确认',
  'pages.talent.field.tags': '标签',
  'pages.talent.field.tags.placeholder': '输入标签后回车确认',
  'pages.talent.field.age': '年龄',
  'pages.talent.field.age.placeholder': '请输入年龄',
  'pages.talent.field.work.experience': '工作年限',
  'pages.talent.field.work.experience.placeholder': '请输入工作年限（年）',
  'pages.talent.field.notes': '备注',
  'pages.talent.field.notes.placeholder': '请输入备注信息',
  'pages.talent.field.avatar': '头像',
  'pages.talent.field.avatar.upload': '上传头像',
  'pages.talent.field.avatar.uploading': '上传中...',
  'pages.talent.basic.info': '基础信息',
  'pages.talent.import.parse': '解析简历',
  'pages.talent.work.history': '工作经历',
  'pages.talent.project.experience': '项目经历',
  'pages.talent.education.experience': '教育经历',
  'pages.talent.field.project.name': '项目名称',
  'pages.talent.field.project.role': '项目职位',
  'pages.talent.field.school': '学校',
  'pages.talent.field.major': '专业',
  'pages.talent.field.degree': '学历',
  'pages.talent.field.is.fulltime': '是否统招',
  'pages.talent.remove': '删除',
  'pages.talent.field.company': '公司名称',
  'pages.talent.field.department': '部门',
  'pages.talent.field.position': '职位',
  'pages.talent.field.start.date': '开始时间',
  'pages.talent.field.end.date': '结束时间',
  'pages.talent.field.is.current': '至今/目前在职',
  'pages.talent.field.description': '描述',
  'pages.talent.add.work.history': '新增工作经历',
  'pages.talent.add.project': '新增项目经历',
  'pages.talent.add.education': '新增教育经历',
  'pages.talent.action.save': '保存',
  'pages.talent.advanced.search.title': '人才筛选',
  'pages.talent.search': '搜索',
  'pages.talent.cancel': '取消',
  'pages.talent.reset': '重置',
  'pages.talent.add.manual': '手工录入',
  'pages.talent.add.import': '导入附件',
  'pages.talent.collection.add': '加入收藏',
  'pages.talent.collection.create': '创建收藏夹',
  'pages.talent.collection.edit': '编辑收藏夹',
  'pages.talent.collection.delete': '删除收藏夹',
  'pages.talent.collection.name': '收藏夹名称',
  'pages.talent.collection.description': '收藏夹描述',
  'pages.talent.collection.talent.count': '人才数量',
  'pages.talent.collection.select': '选择收藏夹',
  'pages.talent.collection.create.new': '创建新收藏夹',
  'pages.talent.collection.add.success': '加入收藏夹成功',
  'pages.talent.collection.remove.success': '从收藏夹移除成功',
  'pages.talent.collection.create.success': '收藏夹创建成功',
  'pages.talent.collection.update.success': '收藏夹更新成功',
  'pages.talent.collection.delete.success': '收藏夹删除成功',
  'pages.talent.collection.delete.confirm': '确定要删除这个收藏夹吗？',
  'pages.talent.collection.name.required': '请输入收藏夹名称',
  'pages.talent.collection.load.failed': '加载收藏夹列表失败',
  'pages.talent.import.title': '导入附件',
  'pages.talent.import.file.label': '简历文件',
  'pages.talent.import.file.required': '请选择简历文件',
  'pages.talent.import.file.hint': '点击或拖拽简历文件到此区域上传',
  'pages.talent.import.file.support':
    '支持 PDF、DOC、DOCX、PNG、JPG、JPEG 格式，文件大小不超过 20MB',
  'pages.talent.import.uploading': '上传中...',
  'pages.talent.import.success': '文件上传成功，正在解析...',
  'pages.talent.import.parse.info': '简历解析功能开发中，请稍后',
  'pages.talent.import.failed': '文件上传失败',
  'pages.talent.field.age.min': '最小年龄',
  'pages.talent.field.age.max': '最大年龄',
  'pages.talent.field.phone.search': '电话',
  'pages.talent.field.phone.search.placeholder': '请输入电话',
  'pages.talent.field.email.search': '邮箱',
  'pages.talent.field.email.search.placeholder': '请输入邮箱',
  'pages.talent.field.current.salary.min': '现薪资下限',
  'pages.talent.field.current.salary.max': '现薪资上限',
  'pages.talent.field.work.experience.min': '最小值',
  'pages.talent.field.work.experience.max': '最大值',
  'pages.talent.field.source': '来源渠道',
  'pages.talent.field.source.placeholder': '请输入来源渠道',
  'pages.talent.detail.load.failed': '加载人才详情失败，请稍后重试。',
  'pages.talent.detail.not.found': '未找到对应的人才。',
  'pages.talent.detail.back': '返回',
  'pages.talent.detail.position.placeholder': '暂无职位或公司信息',
  'pages.talent.detail.years.unit': '年',
  'pages.talent.detail.section.empty': '暂无数据',
  'pages.talent.detail.basic.info': '基础信息',
  'pages.talent.detail.current.salary': '现薪资',
  'pages.talent.detail.expected.salary': '期望薪资',
  'pages.talent.detail.work.experience': '工作年限',
  'pages.talent.detail.created.at': '创建时间',
  'pages.talent.detail.updated.at': '更新时间',
  'pages.talent.detail.skills.section': '技能标签',
  'pages.talent.detail.tags.section': '个性标签',
  'pages.talent.detail.tab.basic.info': '基础信息',
  'pages.talent.detail.tab.attachments': '附件简历',
  'pages.talent.detail.attachments.empty': '暂未上传附件简历',
  'pages.talent.detail.attachments.title': '附件简历',
  'pages.talent.detail.attachments.upload': '上传简历',
  'pages.talent.detail.attachments.file.name': '文件名',
  'pages.talent.detail.attachments.type': '类型',
  'pages.talent.detail.attachments.size': '大小',
  'pages.talent.detail.attachments.uploaded.at': '上传时间',
  'pages.talent.detail.attachments.primary': '主简历',
  'pages.talent.detail.attachments.primary.mark': '设为主简历',
  'pages.talent.detail.attachments.delete': '删除',
  'pages.talent.detail.attachments.delete.confirm': '确定要删除该附件简历吗？',
  'pages.talent.detail.attachments.upload.success': '附件简历上传成功',
  'pages.talent.detail.attachments.upload.failed': '附件简历上传失败',
  'pages.talent.detail.attachments.load.failed': '加载附件简历列表失败',
  'pages.talent.detail.download': '下载',
  'pages.talent.detail.preview': '预览',
  'pages.talent.detail.closePreview': '关闭预览',
  'pages.talent.detail.file.size': '文件大小',
  'pages.talent.detail.file.type': '文件类型',
  'pages.talent.detail.resume.download.failed': '下载链接不可用',

  // 人才详情 - 操作按钮
  'pages.talent.action.favorite': '收藏',
  'pages.talent.action.favorited': '已收藏',
  'pages.talent.action.add.to.project': '加入项目',
  'pages.talent.action.add.note': '添加备注',

  // 人才详情 - 标签页
  'pages.talent.detail.tab.resume.original': '简历原件',
  'pages.talent.detail.tab.online.resume': '在线简历',
  'pages.talent.detail.tab.projects': '参与项目',
  'pages.talent.detail.tab.notes': '备注',
  'pages.talent.detail.tab.operation.logs': '操作记录',
  'pages.talent.detail.tab.recommendation.reports': '推荐报告',
  'pages.talent.detail.tab.click.records': '点击记录',

  // 人才详情 - 简历相关
  'pages.talent.detail.resume.empty': '暂无简历原件',
  'pages.talent.detail.resume.no.path': '人才基础信息已加载，但未找到简历路径',
  'pages.talent.detail.resume.not.loaded': '人才信息未加载',
  'pages.talent.detail.online.resume.empty': '暂无在线简历',
  'pages.talent.detail.online.resume.no.file':
    '人才基础信息已加载，但未找到关联的简历文件',
  'pages.talent.detail.attachments.upload.hint':
    '支持 PDF/DOC/DOCX 格式，最大 20MB',

  // 人才详情 - 项目相关
  'pages.talent.detail.projects.empty': '暂无参与项目',
  'pages.talent.detail.project.client': '客户',
  'pages.talent.detail.project.position': '职位',
  'pages.talent.detail.project.score': '评分',
  'pages.talent.detail.project.join.date': '加入时间',

  // 人才详情 - 备注相关
  'pages.talent.detail.notes.empty': '暂无备注',
  'pages.talent.detail.note.user': '用户',
  'pages.talent.detail.note.system': '系统',
  'pages.talent.detail.note.reminder.target': '提醒对象',
  'pages.talent.detail.note.reminder.time': '提醒时间',

  // 人才详情 - 备注类型
  'pages.talent.note.type.candidate.call': '候选人电话',
  'pages.talent.note.type.consultant.interview': '顾问面试',
  'pages.talent.note.type.consultant.interview.detail': '顾问面试详细',
  'pages.talent.note.type.client.call': '客户电话',
  'pages.talent.note.type.client.visit': '客户拜访',
  'pages.talent.note.type.other': '其他',

  // 人才详情 - 备注状态
  'pages.talent.note.status.want.opportunity': '想看机会',
  'pages.talent.note.status.stable': '现状稳定',
  'pages.talent.note.status.need.contact': '需要联系',
  'pages.talent.note.status.blacklisted': '黑名单',
  'pages.talent.note.status.phone.off': '关机',
  'pages.talent.note.status.empty.number': '空号',
  'pages.talent.note.status.no.status': '无状态',

  // 人才详情 - 推荐报告
  'pages.talent.detail.recommendation.reports.empty': '暂无推荐报告',
  'pages.talent.detail.recommendation.report.title': '推荐报告',
  'pages.talent.detail.recommendation.report.view': '查看',
  'pages.talent.detail.recommendation.report.view.todo':
    '查看报告详情功能待实现',
  'pages.talent.detail.recommendation.report.status.published': '已发布',
  'pages.talent.detail.recommendation.report.status.draft': '草稿',
  'pages.talent.detail.recommendation.report.status.archived': '已归档',
  'pages.talent.detail.recommendation.report.type.standard': '标准',
  'pages.talent.detail.recommendation.report.type.detailed': '详细',
  'pages.talent.detail.recommendation.report.type.executive': '高管',
  'pages.talent.detail.recommendation.report.type.custom': '自定义',
  'pages.talent.detail.recommendation.report.job': '职位',
  'pages.talent.detail.recommendation.report.match.score': '匹配度',
  'pages.talent.detail.recommendation.report.reason': '推荐理由',
  'pages.talent.detail.recommendation.report.created.at': '创建时间',
  'pages.talent.detail.recommendation.report.created.by': '创建人',
  'pages.talent.detail.recommendation.report.view.count': '查看',
  'pages.talent.detail.recommendation.report.view.count.unit': '次',

  // 人才详情 - 点击记录
  'pages.talent.detail.click.records.empty': '暂无点击记录',
  'pages.talent.detail.click.record.owner': '所有者',
  'pages.talent.detail.click.record.resume.id': '简历ID',

  // 人才详情 - 加入项目弹窗
  'pages.talent.modal.add.to.project.title': '加入项目',
  'pages.talent.modal.add.to.project.ok': '确认添加',
  'pages.talent.modal.add.to.project.cancel': '取消',
  'pages.talent.modal.add.to.project.select': '选择项目',
  'pages.talent.modal.add.to.project.select.required': '请选择要加入的项目',
  'pages.talent.modal.add.to.project.select.placeholder': '请选择项目',
  'pages.talent.modal.add.to.project.loading': '加载中...',
  'pages.talent.modal.add.to.project.no.projects': '暂无项目',
  'pages.talent.modal.add.to.project.notes': '备注',
  'pages.talent.modal.add.to.project.notes.tooltip': '可填写推荐理由或其他说明',
  'pages.talent.modal.add.to.project.notes.placeholder':
    '可填写推荐理由、人才优势或其他说明信息',

  // 人才详情 - 添加备注弹窗
  'pages.talent.modal.add.note.title': '备注',
  'pages.talent.modal.add.note.ok': '确认添加',
  'pages.talent.modal.add.note.cancel': '取消',
  'pages.talent.modal.add.note.content': '备注',
  'pages.talent.modal.add.note.content.required': '请输入备注内容',
  'pages.talent.modal.add.note.content.max': '备注内容不能超过5000个字符',
  'pages.talent.modal.add.note.content.placeholder':
    '请输入备注内容，支持多行文本',
  'pages.talent.modal.add.note.reminder.target': '提醒对象',
  'pages.talent.modal.add.note.reminder.target.placeholder': '请输入提醒对象',

  // client
  'pages.client.title': '客户管理',
  'pages.client.subtitle': '维护客户信息，掌握合作进展。',
  'pages.client.search.placeholder': '搜索公司、联系人、行业...',
  'pages.client.filter.level': '按等级筛选',
  'pages.client.filter.status': '按状态筛选',
  'pages.client.advanced.search': '高级搜索',
  'pages.client.add.client': '新增客户',
  'pages.client.collection.create': '创建收藏夹',
  'pages.client.items': '条记录',
  'pages.client.no.data': '暂无客户数据',
  'pages.client.load.failed': '加载客户列表失败，请稍后重试。',
  'pages.client.update.success': '客户更新成功',
  'pages.client.create.success': '客户创建成功',
  'pages.client.save.failed': '保存客户失败，请稍后重试。',
  'pages.client.modal.edit.title': '编辑客户',
  'pages.client.modal.add.title': '新增客户',
  'pages.client.column.company': '公司',
  'pages.client.column.location': '所在地',
  'pages.client.column.level': '等级',
  'pages.client.column.status': '状态',
  'pages.client.column.projects': '项目数',
  'pages.client.column.revenue': '营收',
  'pages.client.column.owner': '归属顾问',
  'pages.client.column.updated.at': '更新时间',
  'pages.client.column.actions': '操作',
  'pages.client.action.view': '查看',
  'pages.client.action.edit': '编辑',
  'pages.client.action.create.job': '创建职位',
  'pages.client.action.delete': '删除',
  'pages.client.action.save': '保存',
  'pages.client.delete.confirm.title': '删除客户',
  'pages.client.delete.confirm.content':
    '确定要删除客户"{companyName}"吗？此操作不可恢复。',
  'pages.client.delete.success': '删除客户成功',
  'pages.client.delete.failed': '删除客户失败',
  'pages.client.level.all': '全部等级',
  'pages.client.level.a': 'A级',
  'pages.client.level.b': 'B级',
  'pages.client.level.c': 'C级',
  'pages.client.status.all': '全部状态',
  'pages.client.status.active': '活跃',
  'pages.client.status.potential': '潜在',
  'pages.client.status.lost': '已流失',
  'pages.client.field.name': '公司名称',
  'pages.client.field.name.required': '请输入公司名称',
  'pages.client.field.name.placeholder': '请输入公司名称',
  'pages.client.field.industry': '行业',
  'pages.client.field.industry.placeholder': '请输入行业',
  'pages.client.field.source': '客户来源',
  'pages.client.field.source.placeholder': '请选择客户来源',
  'pages.client.field.scale': '公司规模',
  'pages.client.field.scale.placeholder': '请输入规模',
  'pages.client.field.level': '客户等级',
  'pages.client.field.level.placeholder': '请选择等级',
  'pages.client.field.status': '状态',
  'pages.client.field.status.placeholder': '请选择状态',
  'pages.client.field.city': '城市',
  'pages.client.field.city.placeholder': '请输入城市',
  'pages.client.field.development.stage': '发展阶段',
  'pages.client.field.development.stage.placeholder': '请选择发展阶段',
  'pages.client.field.enterprise.nature': '企业性质',
  'pages.client.field.enterprise.nature.placeholder': '请选择企业性质',
  'pages.client.field.company.type': '公司类型',
  'pages.client.field.company.type.placeholder': '请选择公司类型',
  'pages.client.field.location': '所在地',
  'pages.client.field.location.placeholder': '请输入所在地',
  'pages.client.field.website': '公司官网',
  'pages.client.field.website.placeholder': '请输入公司官网地址',
  'pages.client.field.founded.at': '成立时间',
  'pages.client.field.business.revenue': '营业收入（销售业绩）',
  'pages.client.field.financing.status': '融资情况 / 上市市值',
  'pages.client.field.company.overview': '公司概况（含核心技术人员）',
  'pages.client.field.people.scale.description':
    '人员规模（人数、学历结构、人员来源等）',
  'pages.client.field.org.structure': '组织架构与职级',
  'pages.client.field.development.strategy': '公司发展战略',
  'pages.client.field.development.prospect': '公司发展前景（含核心技术人员）',
  'pages.client.field.main.products':
    '公司产品（主营业务、产品线或行业排名等）',
  'pages.client.field.main.competitors': '主要竞争对手（主要客户）',
  'pages.client.field.competitor.advantages.and.disadvantages':
    '主要竞争对手优势与劣势',
  'pages.client.field.employer.brand.highlights': '公司优势与对人才的吸引点',
  'pages.client.field.salary.and.benefits':
    '薪酬与福利（车补、餐补、租房补贴等）',
  'pages.client.field.commute.and.environment': '通勤体验与办公环境',
  'pages.client.field.product.and.business.goals':
    '现有产品与业务的短期 / 中期战略目标',
  'pages.client.field.tags': '标签',
  'pages.client.field.tags.placeholder': '输入标签后回车确认',
  'pages.client.field.description': '公司简介',
  'pages.client.field.contact.name': '联系人姓名',
  'pages.client.field.contact.name.required': '请输入联系人姓名',
  'pages.client.field.contact.name.placeholder': '请输入联系人姓名',
  'pages.client.field.contact.phone': '联系电话',
  'pages.client.field.contact.phone.required': '请输入联系电话',
  'pages.client.field.contact.phone.placeholder':
    '请输入手机号或座机号（如：010-12345678）',
  'pages.client.field.contact.position': '职位',
  'pages.client.field.contact.position.placeholder': '请输入职位',
  'pages.client.field.contact.email': '邮箱',
  'pages.client.field.contact.email.placeholder': '请输入邮箱地址',
  'pages.client.field.contact.wechat': '微信号',
  'pages.client.field.contact.wechat.placeholder': '请输入微信号',
  'pages.client.advanced.search.title': '客户筛选',
  'pages.client.search': '搜索',
  'pages.client.cancel': '取消',
  'pages.client.company.name': '公司名称',
  'pages.client.industry': '行业',
  'pages.client.scale': '公司规模',
  'pages.client.location': '所在地',
  'pages.client.website': '网站',
  'pages.client.description': '公司介绍',

  // project
  'pages.project.title': '项目管理',
  'pages.project.subtitle':
    '从职位到交付全链路跟踪，掌握负责人、客户与进度健康度。',
  'pages.project.search.placeholder': '搜索项目名称、客户、职位或负责人...',
  'pages.project.filter.status': '按状态筛选',
  'pages.project.advanced.search': '高级筛选',
  'pages.project.add.project': '新增项目',
  'pages.project.edit.project': '编辑项目',
  'pages.project.load.failed': '加载项目列表失败，请稍后重试。',
  'pages.project.load.jobs.failed': '加载职位列表失败。',
  'pages.project.load.clients.failed': '加载客户列表失败。',
  'pages.project.load.members.failed': '加载团队成员失败。',
  'pages.project.create.success': '创建项目成功',
  'pages.project.update.success': '更新项目成功',
  'pages.project.save.failed': '保存项目失败，请稍后重试。',
  'pages.project.items': '条项目',
  'pages.project.no.data': '暂无项目数据',
  'pages.project.jobs.empty': '暂无职位',
  'pages.project.clients.empty': '暂无客户',
  'pages.project.members.empty': '暂无成员',
  'pages.project.modal.save': '保存',
  'pages.project.modal.cancel': '取消',
  'pages.project.cancel': '取消',
  'pages.project.advanced.title': '高级筛选',
  'pages.project.advanced.reset': '重置',
  'pages.project.advanced.cancel': '取消',
  'pages.project.advanced.submit': '应用',
  'pages.project.column.name': '项目名称',
  'pages.project.field.unknown.job': '未知职位',
  'pages.project.field.unknown.client': '未知客户',
  'pages.project.column.recruiter': '负责人',
  'pages.project.column.priority': '优先级',
  'pages.project.column.status': '状态',
  'pages.project.column.candidates': '候选人',
  'pages.project.total.candidates': '人推荐',
  'pages.project.success.candidates': '人成功',
  'pages.project.column.budget': '预算',
  'pages.project.column.deadline': '截止日期',
  'pages.project.column.progress': '进度',
  'pages.project.column.actions': '操作',
  'pages.project.action.view': '查看',
  'pages.project.action.edit': '编辑',
  'pages.project.priority.urgent': '紧急',
  'pages.project.priority.high': '高',
  'pages.project.priority.medium': '中',
  'pages.project.priority.low': '低',
  'pages.project.status.planning': '规划中',
  'pages.project.status.in.progress': '进行中',
  'pages.project.status.on.hold': '暂停中',
  'pages.project.status.completed': '已完成',
  'pages.project.status.cancelled': '已取消',
  'pages.project.field.name': '项目名称',
  'pages.project.field.name.required': '请输入项目名称',
  'pages.project.field.name.placeholder': '请输入项目名称',
  'pages.project.field.job': '关联职位',
  'pages.project.field.job.required': '请选择关联职位',
  'pages.project.field.job.placeholder': '搜索职位名称或客户',
  'pages.project.field.client': '客户',
  'pages.project.field.client.required': '请选择客户',
  'pages.project.field.client.placeholder': '请选择客户',
  'pages.project.field.client.linked': '关联客户',
  'pages.project.field.recruiter': '负责人',
  'pages.project.field.recruiter.required': '请选择负责人',
  'pages.project.field.recruiter.placeholder': '请选择负责人',
  'pages.project.field.priority': '优先级',
  'pages.project.field.priority.required': '请选择优先级',
  'pages.project.field.priority.placeholder': '请选择优先级',
  'pages.project.field.status': '状态',
  'pages.project.field.status.required': '请选择状态',
  'pages.project.field.status.placeholder': '请选择状态',
  'pages.project.field.start.date': '开始时间',
  'pages.project.field.start.date.required': '请选择开始时间',
  'pages.project.field.start.date.placeholder': '请选择日期',
  'pages.project.field.end.date': '结束时间',
  'pages.project.field.end.date.required': '请选择结束时间',
  'pages.project.field.end.date.placeholder': '请选择日期',
  'pages.project.field.deadline': '截止时间',
  'pages.project.field.deadline.required': '请选择截止时间',
  'pages.project.field.deadline.placeholder': '请选择日期',
  'pages.project.field.budget': '预算',
  'pages.project.field.budget.required': '请输入预算',
  'pages.project.field.budget.placeholder': '请输入预算金额',
  'pages.project.field.fee': '服务费',
  'pages.project.field.fee.required': '请输入服务费',
  'pages.project.field.fee.placeholder': '请输入服务费金额',
  'pages.project.field.fee.rate': '服务费比例',
  'pages.project.field.fee.rate.placeholder': '请输入服务费比例（0-100%）',
  'pages.project.field.notes': '备注',
  'pages.project.field.notes.placeholder': '填写补充信息',
  'pages.project.create.job.btn': '创建职位',
  'pages.project.create.client.btn': '创建客户',
  'pages.project.recruiter': '负责人',
  'pages.project.recruiter.required': '请选择负责人',
  'pages.project.recruiter.placeholder': '请选择负责人',
  'pages.project.load.candidates.failed': '加载候选人列表失败',
  'pages.project.load.interviews.failed': '加载面试记录失败',
  'pages.project.detail.load.failed': '加载项目详情失败',
  'pages.project.detail.load.candidates.failed': '加载候选人列表失败',
  'pages.project.detail.load.interviews.failed': '加载面试记录失败',
  'pages.project.detail.load.members.failed': '加载团队成员列表失败',
  'pages.project.detail.load.talents.failed': '加载人才列表失败',
  'pages.project.detail.update.success': '项目更新成功',
  'pages.project.detail.update.failed': '项目更新失败',
  'pages.project.detail.candidate.already.exists':
    '该人才已经在此项目中，不能重复添加',
  'pages.project.detail.add.candidate.success': '候选人添加成功',
  'pages.project.detail.add.candidate.failed': '候选人添加失败',
  'pages.project.detail.update.status.success': '状态更新成功',
  'pages.project.detail.update.status.failed': '状态更新失败',
  'pages.project.detail.select.candidate.first': '请先选择候选人',
  'pages.project.detail.add.interview.success': '面试记录添加成功',
  'pages.project.detail.add.interview.failed': '面试记录添加失败',
  'pages.project.detail.send.invitation': '发送面试邀请',
  'pages.project.detail.send.invitation.success': '面试邀请发送成功',
  'pages.project.detail.send.invitation.failed': '面试邀请发送失败',
  'pages.project.detail.actions': '操作',
  'pages.project.detail.basic.info': '基本信息',
  'pages.project.detail.candidates': '候选人列表',
  'pages.project.detail.interviews': '面试记录',
  'pages.project.detail.name': '项目名称',
  'pages.project.detail.status': '项目状态',
  'pages.project.detail.priority': '优先级',
  'pages.project.detail.start.date': '开始日期',
  'pages.project.detail.end.date': '结束日期',
  'pages.project.detail.deadline': '截止日期',
  'pages.project.detail.budget': '项目预算',
  'pages.project.detail.fee': '服务费',
  'pages.project.detail.description': '项目描述',
  'pages.project.detail.notes': '备注',
  'pages.project.detail.created.at': '创建时间',
  'pages.project.detail.updated.at': '更新时间',
  'pages.project.detail.total.candidates': '总候选人数',
  'pages.project.detail.success.candidates': '成功候选人数',
  'pages.project.detail.success.rate': '成功率',
  'pages.project.detail.overdue': '已逾期',
  'pages.project.detail.edit.project': '编辑项目',
  'pages.project.detail.name.required': '请输入项目名称',
  'pages.project.detail.add.candidate': '添加候选人',
  'pages.project.detail.add.candidates.to.project': '将候选人加入项目',
  'pages.project.detail.last.contact.record': '最近联系记录',
  'pages.project.detail.batch.import': '批量导入',
  'pages.project.detail.batch.import.quota.loading': '正在查询私池剩余额度…',
  'pages.project.detail.batch.import.quota.failed':
    '私池额度查询失败，请重试后上传',
  'pages.project.detail.batch.import.quota.retry': '重新查询',
  'pages.project.detail.batch.import.quota.auto.join':
    '导入的候选人将自动加入您的私池',
  'pages.project.detail.batch.import.quota.remaining':
    '当前私池已使用 {used}/{limit} 个名额，剩余 {remaining} 个，本次最多可导入 {remaining} 份简历',
  'pages.project.detail.batch.import.quota.unlimited':
    '当前私池已使用 {used} 个名额，上传数量不限',
  'pages.project.detail.batch.import.quota.exceeded':
    '私池剩余 {remaining} 个名额，请减少待导入文件或先释放私池名额',
  'pages.project.detail.batch.import.invalid.type':
    '格式不支持，仅支持 PDF/DOC/DOCX',
  'pages.project.detail.batch.import.too.large': '大小超过 20MB，已跳过',
  'pages.project.detail.batch.import.parse.failed': '简历解析失败',
  'pages.project.detail.batch.import.missing.name':
    '简历中缺少姓名信息，请补充后重新导入',
  'pages.project.detail.batch.import.missing.contact':
    '简历中缺少联系方式，请至少补充邮箱或电话后重新导入',
  'pages.project.detail.batch.import.existing.talent.used':
    '已复用已有的人才，加入您的私池并关联到项目',
  'pages.project.detail.batch.import.success': '导入成功，已加入您的私池',
  'pages.project.detail.batch.import.failed': '导入失败',
  'pages.project.detail.batch.import.no.files': '请先选择要导入的简历文件',
  'pages.project.detail.batch.import.no.pending': '没有待处理的文件',
  'pages.project.detail.batch.import.processing': '处理中',
  'pages.project.detail.batch.import.status.success': '成功',
  'pages.project.detail.batch.import.status.error': '失败',
  'pages.project.detail.batch.import.status.phone.conflict': '手机号重复',
  'pages.project.detail.batch.import.status.pending': '待处理',
  'pages.project.detail.batch.import.summary.empty': '尚未选择文件',
  'pages.project.detail.batch.import.summary':
    '共 {total} 个文件，成功 {success} 个，失败 {failed} 个',
  'pages.project.detail.batch.import.closing.blocked':
    '正在导入中，请稍候完成后再关闭',
  'pages.project.detail.batch.import.title': '批量导入候选人',
  'pages.project.detail.batch.import.start': '开始导入',
  'pages.project.detail.batch.import.drag.tip': '点击或拖拽文件到此区域上传',
  'pages.project.detail.batch.import.hint':
    '支持多文件导入，格式：PDF / DOC / DOCX，单个文件不超过 20MB',
  'pages.project.detail.batch.import.list.empty': '暂未选择文件',
  'pages.project.detail.batch.import.name.placeholder': '姓名（必填）',
  'pages.project.detail.batch.import.email.placeholder': '邮箱',
  'pages.project.detail.batch.import.phone.placeholder': '手机号',
  'pages.project.detail.batch.import.supplement.need.name':
    '缺少姓名信息，请补充后重新导入',
  'pages.project.detail.batch.import.supplement.need.contact':
    '缺少联系方式，请至少补充邮箱或电话后重新导入',
  'pages.project.detail.batch.import.supplement.saved': '补充信息已保存',
  'pages.project.detail.batch.import.supplement.save': '保存补充信息',
  'pages.project.detail.batch.select.from.collection': '批量从收藏夹选择',
  'pages.project.detail.select.collection': '选择收藏夹',
  'pages.project.detail.select.collection.placeholder': '请选择收藏夹',
  'pages.project.detail.select.collection.first': '请先选择收藏夹',
  'pages.project.detail.search.from.talent.pool': '从人才库搜索',
  'pages.project.detail.export.success': '导出成功',
  'pages.project.detail.export.failed': '导出失败',
  'pages.project.detail.export.no.data': '没有可导出的数据',
  'pages.project.detail.export.loading': '正在加载数据...',
  'pages.project.detail.generate.recommendation.report': '生成推荐报告',
  'pages.project.detail.ai.matching.analysis': 'AI匹配分析',
  'pages.project.detail.matching.no.job': '项目未关联职位，无法进行匹配分析',
  'pages.project.detail.matching.no.talent': '候选人未关联人才信息',
  'pages.project.detail.matching.failed': 'AI 匹配分析失败',
  'pages.project.detail.more.actions': '更多功能',
  'pages.project.detail.highlight': '高亮',
  'pages.project.detail.help': '帮助',
  'pages.project.detail.batch.update': '批量更新',
  'pages.project.detail.batch.remove': '批量移出项目',
  'pages.project.detail.remove.candidate': '从项目移除',
  'pages.project.detail.remove.candidate.confirm.title': '确认移除',
  'pages.project.detail.remove.candidate.confirm.content':
    '确定要从项目中移除候选人"{name}"吗？',
  'pages.project.detail.remove.candidate.success': '移除成功',
  'pages.project.detail.remove.candidate.failed': '移除失败',
  'pages.project.detail.batch.remove.confirm.title': '确认批量移除',
  'pages.project.detail.batch.remove.confirm.content':
    '确定要从项目中移除 {count} 位候选人吗？',
  'pages.project.detail.batch.remove.success': '成功移除 {count} 位候选人',
  'pages.project.detail.batch.remove.failed': '批量移除失败',
  'pages.project.detail.batch.remove.no.selection': '请选择要移除的候选人',
  'pages.project.detail.all.talent': '所有人才',
  'pages.project.detail.stage.join.project': '加入项目',
  'pages.project.detail.stage.recommend.to.client': '推荐给客户',
  'pages.project.detail.stage.arrange.client.interview': '安排客户面试',
  'pages.project.detail.stage.offer.signed': '签订Offer',
  'pages.project.detail.stage.performance.allocation': '业绩分配',
  'pages.project.detail.stage.onboarded': '入职',
  'pages.project.detail.stage.eliminated': '淘汰',
  'pages.project.detail.not.recommended': '未推荐',
  'pages.project.detail.recommended.not.interviewed': '已推荐未面试',
  'pages.project.detail.client.interview': '客户面试',
  'pages.project.detail.offer.signed': '签订Offer',
  'pages.project.detail.eliminated': '淘汰',
  'pages.project.detail.no.permission.view.client': '无权限查看该客户详情',
  'pages.project.detail.no.permission.operate.candidate':
    '无权限操作该候选人（他人私池人才）',
  'pages.project.detail.no.permission.operate.candidate.short': '无权限',
  'pages.project.detail.active.talent': '活动中人才',
  'pages.project.detail.candidate.name': '候选人姓名',
  'pages.project.detail.phone': '联系电话',
  'pages.project.detail.stage': '当前阶段',
  'pages.project.detail.candidate.status': '候选人状态',
  'pages.project.detail.score': '评分',
  'pages.project.detail.recommended.at': '推荐时间',
  'pages.project.detail.add.interview': '新增面试',
  'pages.project.detail.select.talent': '选择人才',
  'pages.project.detail.select.talent.placeholder': '请选择人才',
  'pages.project.detail.talent.required': '请选择人才',
  'pages.project.detail.stage.placeholder': '请输入阶段',
  'pages.project.detail.select.candidate': '选择候选人',
  'pages.project.detail.select.candidate.placeholder': '请选择候选人',
  'pages.project.detail.candidate.required': '请选择候选人',
  'pages.project.detail.interview.round': '面试轮次',
  'pages.project.detail.interview.type': '面试类型',
  'pages.project.detail.scheduled.date': '计划时间',
  'pages.project.detail.interview.status': '面试状态',
  'pages.project.detail.interview.result': '面试结果',
  'pages.project.detail.interview.score': '面试评分',
  'pages.project.detail.location': '面试地点',
  'pages.project.detail.duration': '面试时长',
  'pages.project.detail.minutes': '分钟',
  'pages.project.detail.location.placeholder': '请输入面试地点或链接',
  'pages.project.detail.interviewers': '面试官',
  'pages.project.detail.interviewers.placeholder':
    '请输入面试官信息 (JSON格式)',
  'pages.project.detail.interviewers.invalid.json':
    '面试官信息格式不正确，将作为文本保存',
  'pages.project.detail.round.required': '请输入面试轮次',
  'pages.project.detail.type.required': '请选择面试类型',
  'pages.project.detail.scheduled.date.required': '请选择面试时间',
  'pages.project.detail.select.date.time': '选择日期时间',
  'pages.project.detail.client': '客户',
  'pages.project.detail.job': '职位',
  'pages.project.detail.client.info': '客户信息',
  'pages.project.detail.view.client.detail': '查看客户详情',
  'pages.project.detail.view.job': '查看职位',
  'pages.project.detail.view.job.detail': '查看职位详情',
  'pages.project.detail.no.client.info': '暂未关联客户',
  'pages.project.detail.operation.logs': '操作记录',
  'pages.project.detail.ai.match': 'AI匹配',
  'pages.project.detail.ai.match.title': '按岗位「{jobTitle}」从全部人才中匹配',
  'pages.project.detail.ai.match.desc':
    '先用岗位描述和职位模型做规则预筛，再对勾选的人做 AI 深匹配。查看详情和加入项目仍走私池权限。',
  'pages.project.detail.ai.match.no.job':
    '项目未关联职位，请先到职位信息中关联岗位后再做 AI 匹配',
  'pages.project.detail.ai.match.load.failed': '加载规则匹配失败',
  'pages.project.detail.ai.match.refresh': '刷新规则匹配',
  'pages.project.detail.ai.match.run.selected': '对勾选的 {count} 人做 AI 匹配',
  'pages.project.detail.ai.match.run.preview': '对预筛结果做 AI 匹配',
  'pages.project.detail.ai.match.run.one': '对该人做 AI 匹配',
  'pages.project.detail.ai.match.run.success':
    '已分析 {queued} 人，跳过 {skipped} 人，失败 {failed} 人',
  'pages.project.detail.ai.match.run.failed': 'AI 匹配失败',
  'pages.project.detail.ai.match.no.targets':
    '没有可分析的人才，请先勾选有权限且尚未分析的人',
  'pages.project.detail.ai.match.no.permission':
    '没有该人才的私池权限，无法查看或加入项目',
  'pages.project.detail.ai.match.summary':
    '预筛 {total} 人，其中 {analyzed} 人已有 AI 结果，{pending} 人待分析。本次最多分析 20 人。',
  'pages.project.detail.ai.match.tab.preview': '规则预筛 ({count})',
  'pages.project.detail.ai.match.tab.analyzed': '已 AI 匹配 ({count})',
  'pages.project.detail.ai.match.empty': '暂无匹配结果，可先刷新规则匹配',
  'pages.project.detail.ai.match.name': '人才',
  'pages.project.detail.ai.match.location': '城市',
  'pages.project.detail.ai.match.rule.score': '规则分',
  'pages.project.detail.ai.match.ai.score': 'AI分',
  'pages.project.detail.ai.match.keywords': '命中关键词',
  'pages.project.detail.ai.match.status': '状态',
  'pages.project.detail.ai.match.analyzed': '已AI匹配',
  'pages.project.detail.ai.match.rule.matched': '规则匹配',
  'pages.project.detail.ai.match.in.project': '已在项目',
  'pages.project.detail.ai.match.no.pool.permission': '无私池权限',
  'pages.project.detail.ai.match.view.analysis': '查看分析',
  'pages.project.detail.ai.match.add': '加入项目',
  'pages.project.detail.view.candidate.detail': '查看候选人详情',
  'pages.project.detail.talent.position': '职位',
  'pages.project.detail.offer.date': 'Offer日期',
  'pages.project.detail.join.date': '入职日期',
  'pages.project.detail.rejection.reason': '拒绝原因',
  'pages.project.detail.client.feedback': '客户反馈',
  'pages.project.detail.status.history': '状态变更记录',
  'pages.project.detail.no.status.history': '暂无状态变更记录',
  'pages.project.detail.load.status.history.failed': '获取状态变更历史失败',
  'pages.project.detail.edit.status.record': '编辑本条记录',
  'pages.project.detail.edit.interview': '编辑面试',
  'pages.project.detail.edit.status.record.title': '编辑状态记录',
  'pages.project.detail.business.date': '业务日期',
  'pages.project.detail.form.data.snapshot': '表单数据',
  'pages.project.detail.edit.status.record.success': '已保存',
  'pages.project.detail.recommend.to.client.form.title': '推荐给客户',
  'pages.project.detail.recommend.date': '推荐日期',
  'pages.project.detail.recommend.channel': '推荐渠道',
  'pages.project.detail.recommend.channel.phone': '电话',
  'pages.project.detail.recommend.channel.wechat': '微信',
  'pages.project.detail.recommend.channel.email': '邮件',
  'pages.project.detail.recommend.channel.other': '其他',
  'pages.project.detail.client.contact': '客户联系人',
  'pages.project.detail.operated.by': '操作人',
  'pages.project.detail.unknown': '未知',
  'pages.project.detail.email': '邮箱',
  'pages.project.detail.recent.contact': '最近联系记录',
  'pages.project.detail.operation.time': '操作时间',
  'pages.project.detail.user': '用户',
  'pages.project.detail.company': '公司',
  'pages.project.detail.position': '职位',
  'pages.project.detail.annual.salary': '年薪',
  'pages.project.detail.age': '年龄',
  'pages.project.detail.tags': '标签',
  'pages.project.detail.creator': '创建人',
  'pages.project.detail.score.unit': '分',
  'pages.project.detail.round.format': '第{round}轮',
  'pages.project.detail.recommendation.report': '推荐报告',
  'pages.project.detail.recommendation.report.add': '新增推荐报告',
  'pages.project.detail.recommendation.report.load.failed':
    '加载推荐报告列表失败',
  'pages.project.detail.recommendation.report.delete.success': '删除成功',
  'pages.project.detail.recommendation.report.delete.failed': '删除失败',
  'pages.project.detail.recommendation.report.delete.confirm':
    '确定要删除这个推荐报告吗？',
  'pages.project.detail.recommendation.report.type': '报告类型',
  'pages.project.detail.recommendation.report.status': '状态',
  'pages.project.detail.recommendation.report.generated.at': '生成时间',
  'pages.project.detail.recommendation.report.empty': '暂无推荐报告',
  'pages.project.detail.recommendation.report.create.tip':
    '选择候选人后，将跳转到推荐报告生成页面',
  'pages.project.detail.view': '查看',
  'pages.project.detail.edit': '编辑',
  'pages.project.detail.delete': '删除',
  'pages.project.detail.confirm': '确定',
  'pages.project.detail.cancel': '取消',
  'pages.project.detail.total': '共',
  'pages.project.detail.commission.allocation': '业绩分配',
  'pages.project.detail.workflow': '项目流程',
  'pages.project.stage.planning': '项目启动',
  'pages.project.stage.planning.desc': '项目初始化和需求确认',
  'pages.project.stage.in.progress': '进行中',
  'pages.project.stage.in.progress.desc': '项目执行中',
  'pages.project.stage.join.project': '加入项目',
  'pages.project.stage.join.project.desc': '候选人进入项目池',
  'pages.project.stage.recommend.to.client': '推荐给客户',
  'pages.project.stage.recommend.to.client.desc': '向客户推荐候选人',
  'pages.project.stage.arrange.client.interview': '安排客户面试',
  'pages.project.stage.arrange.client.interview.desc': '安排候选人与客户面试',
  'pages.project.stage.offer.signed': '签订Offer',
  'pages.project.stage.offer.signed.desc': 'Offer阶段推进',
  'pages.project.stage.performance.allocation': '业绩分配',
  'pages.project.stage.performance.allocation.desc': '完成业绩分配与提成拆分',
  'pages.project.stage.onboarded.desc': '候选人入职完成',
  'pages.project.stage.eliminated': '淘汰',
  'pages.project.detail.stage.yellow.order': '黄单',
  'pages.project.stage.eliminated.desc': '淘汰 / 撤回 / Offer已拒绝',
  'pages.project.stage.candidate.recommendation': '候选人推荐',
  'pages.project.stage.candidate.recommendation.desc': '寻找和推荐候选人',
  'pages.project.stage.interviewing': '面试进行',
  'pages.project.stage.interviewing.desc': '候选人面试阶段',
  'pages.project.stage.offer.negotiation': 'Offer谈判',
  'pages.project.stage.offer.negotiation.desc': '薪资谈判和Offer发放',
  'pages.project.stage.onboarding': '入职完成',
  'pages.project.stage.onboarding.desc': '候选人入职',
  'pages.project.stage.closed': '已关闭',
  'pages.project.stage.closed.desc': '淘汰 / 撤回 / Offer已拒绝',
  'pages.project.detail.no.candidates.in.stage': '该阶段暂无候选人',
  'pages.project.detail.stage.filters': '阶段过滤',
  'pages.project.detail.filter.high.risk': '仅高风险',
  'pages.project.detail.filter.high.priority': '仅高优先级',
  'pages.project.detail.stage.statuses': '包含状态',
  'pages.project.detail.advance.action': '推进操作',
  'pages.project.detail.ai.assistant': 'AI助手',
  'pages.project.detail.ai.copy.failed': '复制失败',
  'pages.project.detail.ai.saved': '已保存',
  'pages.project.detail.ai.saved.notes': '已保存内容',
  'pages.project.detail.ai.next.action': '下一步动作',
  'pages.project.detail.ai.next.action.generated': '已生成下一步动作建议',
  'pages.project.detail.ai.feedback.generated': '已生成反馈建议',
  'pages.project.detail.ai.offer.generated': '已生成 Offer 建议',
  'pages.project.detail.ai.bgcheck.generated': '已生成背调建议',
  'pages.project.detail.ai.recommend': 'AI 推荐',
  'pages.project.detail.ai.recommend.modal.title': 'AI 推荐候选人',
  'pages.project.detail.ai.recommend.generate': '重新生成',
  'pages.project.detail.ai.recommend.job.required': '请先关联职位再使用AI推荐',
  'pages.project.detail.ai.recommend.failed': '获取AI推荐失败，请稍后再试',
  'pages.project.detail.ai.recommend.generated': '已更新推荐列表',
  'pages.project.detail.ai.recommend.stage': 'AI推荐',
  'pages.project.detail.match.score': '匹配度',
  'pages.project.detail.match.reasons': '匹配原因',
  'pages.project.detail.min.match.score': '最低匹配度',
  'pages.project.detail.recommendation.duplicate': '该候选人已在项目中',
  'pages.project.detail.recommendation.add': '加入项目',
  'pages.project.detail.ai.analysis': '项目分析',
  'pages.project.detail.generate.analysis': '生成分析',
  'pages.project.detail.ai.talk.library': '话术库',
  'pages.project.detail.ai.running': 'AI 处理中，请稍候...',
  'pages.project.detail.ai.no.messages':
    '暂无对话记录，点击"生成分析"开始AI分析',
  'pages.project.detail.ai.input.placeholder':
    '输入您的问题，按Enter发送，Shift+Enter换行...',
  'pages.project.detail.ai.you': '你',
  'pages.project.detail.smart.suggestions': '智能建议',
  'pages.project.detail.no.suggestions': '暂无建议，点击刷新生成',
  'pages.project.detail.refresh': '刷新',
  'pages.project.detail.ai.analysis.failed': 'AI分析失败，请稍后重试',
  'pages.project.detail.ai.suggestions.failed': '生成建议失败，请稍后重试',
  'pages.project.detail.ai.chat.failed': 'AI对话失败，请稍后重试',
  'pages.project.detail.current.stage': '当前阶段',
  'pages.project.detail.next.action': '下一步动作',
  'pages.project.detail.next.action.hint': '为候选人补充下一步动作并跟进',
  'pages.project.detail.record.feedback': '记录反馈',
  'pages.project.detail.feedback.failed': '记录反馈失败',
  'pages.project.detail.offer.draft': 'Offer草稿',
  'pages.project.detail.background.check': '发起背调',
  'pages.project.detail.action.schedule': '安排面试',
  'pages.project.detail.view.talent': '查看档案',
  'pages.project.detail.next.action.placeholder': '下一步动作',
  'pages.project.detail.next.owner.placeholder': '负责人',
  'pages.project.detail.next.deadline.placeholder': '截止时间',
  'pages.project.detail.next.action.type': '动作类型',
  'pages.project.detail.next.action.saved': '已保存下一步动作（本地）',
  'pages.project.detail.next.owner.default': '未分配',
  'pages.project.detail.next.deadline.default': '未设定',
  'pages.project.detail.priority.highest': 'P1',
  'pages.project.detail.priority.high': 'P2',
  'pages.project.detail.priority.medium': 'P3',
  'pages.project.detail.priority.low': 'P4',
  'pages.project.detail.risk.high': '高风险',
  'pages.project.detail.risk.medium': '风险',
  'pages.project.detail.risk.rejected': '拒绝/撤回',
  'pages.project.detail.risk.overdue': '超过14天未推进',
  'pages.project.detail.risk.slow': '超过7天未推进',
  'pages.project.detail.risk.interview.stuck': '面试停滞',
  'pages.project.detail.risk.offer.delay': 'Offer延迟',
  'pages.project.detail.next.action.display':
    '动作：{action} · 负责人：{owner} · 截止：{deadline}',
  'pages.project.detail.metric.count': '人数',
  'pages.project.detail.metric.avg.days': '平均停留',
  'pages.project.detail.metric.day': '天',
  'pages.project.detail.metric.conversion': '转化',
  'pages.project.detail.feedback.placeholder': '反馈记录占位',
  'pages.project.detail.offer.placeholder': 'Offer草稿占位',
  'pages.project.detail.bgcheck.placeholder': '背调占位',
  'pages.project.detail.ai.action.plan': '当下三步建议',
  'pages.project.detail.ai.interview.prep': '面试准备/问题建议',
  'pages.project.detail.ai.salary.talk': '谈薪话术/报价锚点',
  'pages.project.detail.ai.recovery': '拒绝/挽回话术',
  'pages.project.detail.ai.action.plan.failed': '获取行动建议失败',
  'pages.project.detail.ai.interview.prep.failed': '获取面试准备失败',
  'pages.project.detail.ai.salary.failed': '获取谈薪话术失败',
  'pages.project.detail.ai.recovery.failed': '获取挽回话术失败',
  'pages.project.detail.risk.rules': '风险规则',
  'pages.project.detail.risk.rules.title': '候选人风险判定规则',
  'pages.project.detail.risk.rules.intro':
    '系统会根据以下规则，为候选人打上高/中/低风险标签，帮助你优先跟进：',
  'pages.project.detail.risk.rule.high.overdue':
    '高风险：推荐超过 14 天仍无明显推进',
  'pages.project.detail.risk.rule.high.offer.delay':
    '高风险：处于 Offer / 薪资谈判阶段超过 10 天未落地',
  'pages.project.detail.risk.rule.medium.slow': '中风险：推荐超过 7 天进展缓慢',
  'pages.project.detail.risk.rule.medium.interview.stuck':
    '中风险：长时间停留在一面 / 二面阶段',
  'pages.project.detail.risk.rule.low': '低风险：新推荐或流程推进顺畅',
  'pages.project.detail.sign.offer': '签订Offer',
  'pages.project.detail.offer.item': '项目',
  'pages.project.detail.offer.amount': '金额(元)',
  'pages.project.detail.offer.quantity': '数量',
  'pages.project.detail.offer.total': '总计',
  'pages.project.detail.offer.remark': '备注',
  'pages.project.detail.offer.annual.salary': '年薪',
  'pages.project.detail.offer.fee.amount': '收费金额',
  'pages.project.detail.offer.confirm.date': '确认日期',
  'pages.project.detail.offer.expected.onboard.date': '预计上班日期',
  'pages.project.detail.offer.status': '状态',
  'pages.project.detail.offer.consultant': 'Offer归属顾问',
  'pages.project.detail.offer.notes': '备注',
  'pages.project.detail.offer.save.success': '签订Offer信息已保存',
  'pages.project.detail.onboard.form.title': '入职',
  'pages.project.detail.onboard.status': '状态',
  'pages.project.detail.onboard.join.date': '入职时间',
  'pages.project.detail.onboard.probation.end.date': '试用期结束',
  'pages.project.detail.onboard.remind.target': '提醒对象',
  'pages.project.detail.onboard.notes': '备注',
  'pages.project.detail.onboard.probation.tip': '试用期结束系统会自动提醒',
  'pages.project.detail.onboard.save.success': '入职信息已保存',

  // candidate
  'pages.candidate.status.added.to.project': '加入项目',
  'pages.candidate.status.recommended': '已推荐',
  'pages.candidate.status.first.interview': '一面',
  'pages.candidate.status.second.interview': '二面',
  'pages.candidate.status.salary.negotiation': '谈薪',
  'pages.candidate.status.offer.sent': 'Offer已发放',
  'pages.candidate.status.offer.accepted': 'Offer已接受',
  'pages.candidate.status.offer.rejected': 'Offer已拒绝',
  'pages.candidate.status.background.check': '背调中',
  'pages.candidate.status.joined': '已入职',
  'pages.candidate.status.rejected': '淘汰',
  'pages.candidate.status.withdrawn': '已撤回',

  // interview
  'pages.interview.type.phone': '电话面试',
  'pages.interview.type.video': '视频面试',
  'pages.interview.type.face.to.face': '面对面面试',
  'pages.interview.type.technical': '技术面试',
  'pages.interview.type.hr': 'HR面试',
  'pages.interview.type.final': '终面',
  'pages.interview.status.scheduled': '已安排',
  'pages.interview.status.in.progress': '进行中',
  'pages.interview.status.completed': '已完成',
  'pages.interview.status.cancelled': '已取消',
  'pages.interview.status.rescheduled': '已改期',
  'pages.interview.result.passed': '通过',
  'pages.interview.result.failed': '未通过',
  'pages.interview.result.pending': '待定',
  'pages.interview.result.cancelled': '已取消',
  'pages.interview.subtitle': '管理和跟踪所有{type}',
  'pages.interview.load.failed': '加载面试列表失败',
  'pages.interview.search.placeholder': '搜索人才或项目名称',
  'pages.interview.filter.status.placeholder': '筛选状态',
  'pages.interview.column.talent.name': '人才姓名',
  'pages.interview.column.project.name': '项目名称',
  'pages.interview.column.round': '面试轮次',
  'pages.interview.round.format': '第{round}轮',
  'pages.interview.column.scheduled.date': '计划时间',
  'pages.interview.column.location': '面试地点',
  'pages.interview.column.status': '状态',
  'pages.interview.column.result': '结果',
  'pages.interview.column.score': '评分',
  'pages.interview.score.format': '{score}分',
  'pages.interview.column.actions': '操作',
  'pages.interview.action.view': '查看详情',
  'pages.interview.action.edit': '编辑',
  'pages.interview.action.delete': '删除',
  'pages.interview.action.execute': '执行',
  'pages.interview.action.more': '更多操作',
  'pages.interview.delete.confirm.title': '删除面试记录',
  'pages.interview.delete.confirm.content':
    '确定要删除这条面试记录吗？此操作无法撤销。',
  'pages.interview.delete.success': '面试记录删除成功',
  'pages.interview.delete.failed': '面试记录删除失败',
  'pages.interview.edit.tip': '请在项目详情页中编辑面试详情。',
  'pages.interview.create.title': '新增面试记录',
  'pages.interview.create.project': '所属项目',
  'pages.interview.create.candidate': '候选人',
  'pages.interview.create.round': '面试轮次',
  'pages.interview.create.type': '面试类型',
  'pages.interview.create.scheduled.date': '计划时间',
  'pages.interview.create.duration': '面试时长（分钟）',
  'pages.interview.create.location': '面试地点',
  'pages.interview.create.status': '面试状态',
  'pages.interview.create.project.placeholder': '请选择项目',
  'pages.interview.create.candidate.placeholder': '请选择候选人',
  'pages.interview.candidate.in.other.pool': '在他人私池中',
  'pages.job.client.in.other.pool': '该客户属于他人私池',
  'pages.client.add.to.private.pool.success': '客户已加入您的私池',
  'pages.interview.create.round.required': '请输入面试轮次',
  'pages.interview.create.type.required': '请选择面试类型',
  'pages.interview.create.scheduled.date.required': '请选择计划时间',
  'pages.interview.create.scheduled.date.placeholder': '请选择计划时间',
  'pages.interview.create.success': '面试记录创建成功',
  'pages.interview.create.failed': '面试记录创建失败',
  'pages.interview.total.results': '总共: {total} 条结果',
  'pages.interview.pagination.total': '{start}-{end} 共 {total} 条',
  'pages.interview.no.data': '暂无面试记录',
  'pages.interview.date.start': '开始日期',
  'pages.interview.date.end': '结束日期',

  // question
  'pages.question.title': '问师傅知识基地',
  'pages.question.subtitle': '集中管理猎头团队的知识沉淀，随时提问与查阅。',
  'pages.question.my.answers.title': '我的回答',
  'pages.question.my.answers.subtitle': '查看并管理自己贡献的所有回答。',
  'pages.question.categories.title': '问题分类',
  'pages.question.categories.subtitle': '维护知识库分类体系，保持内容可导航。',
  'pages.question.add.question': '新建问题',
  'pages.question.categories.add': '新增分类',
  'pages.question.search.placeholder': '按标题、关键词、标签搜索...',
  'pages.question.filter.category': '按分类筛选',
  'pages.question.filter.status': '按状态筛选',
  'pages.question.filter.priority': '按优先级筛选',
  'pages.question.filter.sort': '排序方式',
  'pages.question.sort.latest': '最新',
  'pages.question.sort.hot': '热门',
  'pages.question.sort.unanswered': '待回答',
  'pages.question.sort.resolved': '已解决',
  'pages.question.column.title': '问题',
  'pages.question.column.category': '分类',
  'pages.question.column.status': '状态',
  'pages.question.column.priority': '优先级',
  'pages.question.column.answers': '回答数',
  'pages.question.column.views': '浏览量',
  'pages.question.column.stats': '统计',
  'pages.question.column.created.at': '创建时间',
  'pages.question.column.updated.at': '更新时间',
  'pages.question.column.actions': '操作',
  'pages.question.action.edit': '编辑',
  'pages.question.action.delete': '删除',
  'pages.question.delete.confirm': '确认删除该问题吗？',
  'pages.question.delete.ok': '删除',
  'pages.question.delete.cancel': '取消',
  'pages.question.delete.success': '问题已删除',
  'pages.question.delete.failed': '删除失败，请稍后再试。',
  'pages.question.load.failed': '加载问题列表失败，请稍后再试。',
  'pages.question.categories.load.failed': '加载分类失败，请稍后再试。',
  'pages.question.answers.load.failed': '加载回答失败，请稍后再试。',
  'pages.question.items': '条',
  'pages.question.items.suffix': '个问题',
  'pages.question.no.data': '暂无数据',
  'pages.question.category.unknown': '未分类',
  'pages.question.top': '置顶',
  'pages.question.anonymous': '匿名',
  'pages.question.category.required': '请先创建分类',
  'pages.question.interaction.failed': '操作失败，请稍后重试',
  'pages.question.update.success': '问题已更新',
  'pages.question.create.success': '问题已创建',
  'pages.question.modal.add.title': '新建问题',
  'pages.question.modal.edit.title': '编辑问题',
  'pages.question.modal.save': '保存',
  'pages.question.modal.cancel': '取消',
  'pages.question.field.title': '问题标题',
  'pages.question.field.title.required': '请输入问题标题',
  'pages.question.field.title.placeholder': '例如：如何提升候选人到面率？',
  'pages.question.field.content': '详细描述',
  'pages.question.field.content.required': '请填写问题背景与诉求',
  'pages.question.field.content.placeholder':
    '补充场景、关键数据、期望答案等信息',
  'pages.question.field.category': '所属分类',
  'pages.question.field.category.required': '请选择分类',
  'pages.question.field.category.placeholder': '选择或搜索分类',
  'pages.question.field.priority': '优先级',
  'pages.question.field.priority.required': '请选择优先级',
  'pages.question.field.priority.placeholder': '请选择优先级',
  'pages.question.field.privacy': '可见范围',
  'pages.question.field.reward': '奖励积分',
  'pages.question.field.reward.placeholder': '可选，填写奖励积分',
  'pages.question.field.tags': '标签',
  'pages.question.field.tags.placeholder': '输入后回车添加标签',
  'pages.question.privacy.public': '公开',
  'pages.question.privacy.private': '仅邀请专家',
  'pages.question.save.success': '问题已保存',
  'pages.question.save.failed': '保存问题失败，请稍后再试。',
  'pages.question.status.pending': '待回答',
  'pages.question.status.answered': '已回答',
  'pages.question.status.resolved': '已解决',
  'pages.question.status.closed': '已关闭',
  'pages.question.priority.low': '低',
  'pages.question.priority.normal': '普通',
  'pages.question.priority.high': '高',
  'pages.question.priority.urgent': '紧急',
  'pages.question.ai.answer.failed': '获取AI答案失败，请稍后重试',
  'pages.question.ai.answer.invalid': '问题和答案不能为空',
  'pages.question.ai.answer.saved': '问题和答案已保存',
  'pages.question.ai.question.invalid': '问题不能为空',
  'pages.question.ai.answer.title': 'AI 智能回答',
  'pages.question.ai.answer.accept': '采纳为答案',
  'pages.question.ai.answer.reject': '不采纳',
  'pages.question.ai.answer.save': '保存为问题',
  'pages.question.ai.answer.no.result': '该问题暂无人提问',
  'pages.question.ai.answer.description':
    '系统已为您搜索相关问题，但未找到匹配结果。以下是AI为您生成的回答：',
  'pages.question.ai.answer.question': '问题',
  'pages.question.ai.answer.answer': '回答',
  'pages.question.ai.answer.loading': 'AI正在思考中...',
  'pages.question.ai.answer.empty': '暂无回答内容',
  'pages.question.my.answers.column.question': '问题',
  'pages.question.my.answers.column.content': '回答内容',
  'pages.question.my.answers.column.upvotes': '点赞',
  'pages.question.my.answers.column.status': '状态',
  'pages.question.my.answers.column.stats': '数据',
  'pages.question.my.answers.column.created.at': '回答时间',
  'pages.question.my.answers.column.actions': '操作',
  'pages.question.my.answers.search.placeholder': '搜索问题标题或回答内容...',
  'pages.question.my.answers.sort.placeholder': '排序方式',
  'pages.question.my.answers.sort.latest': '最新回答',
  'pages.question.my.answers.sort.upvotes': '点赞最多',
  'pages.question.my.answers.sort.accepted': '已采纳优先',
  'pages.question.my.answers.status.best': '最佳答案',
  'pages.question.my.answers.status.accepted': '已采纳',
  'pages.question.my.answers.status.normal': '普通回答',
  'pages.question.my.answers.stats.upvotes': '点赞',
  'pages.question.my.answers.stats.comments': '评论',
  'pages.question.my.answers.stats.views': '阅读',
  'pages.question.my.answers.action.view': '查看问题',
  'pages.question.my.answers.action.edit': '编辑',
  'pages.question.my.answers.action.delete': '删除',
  'pages.question.my.answers.delete.confirm': '确定要删除这条回答吗？',
  'pages.question.my.answers.delete.success': '回答已删除',
  'pages.question.my.answers.delete.failed': '删除失败，请稍后再试。',
  'pages.question.my.answers.edit.modal.title': '编辑回答',
  'pages.question.my.answers.field.content': '回答内容',
  'pages.question.my.answers.field.content.required': '请输入回答内容',
  'pages.question.my.answers.field.content.placeholder':
    '分享你的经验与解决方案...',
  'pages.question.my.answers.save.success': '回答已更新',
  'pages.question.my.answers.save.failed': '更新失败，请稍后再试。',
  'pages.question.my.answers.load.failed': '加载回答列表失败，请稍后再试。',
  'pages.question.my.answers.empty.text': '你还没有回答过任何问题',
  'pages.question.categories.column.name': '分类',
  'pages.question.categories.column.code': '编码',
  'pages.question.categories.column.description': '描述',
  'pages.question.categories.column.icon': '图标',
  'pages.question.categories.column.sort': '排序',
  'pages.question.categories.column.count': '问题数',
  'pages.question.categories.column.status': '状态',
  'pages.question.categories.column.actions': '操作',
  'pages.question.categories.status.active': '启用',
  'pages.question.categories.status.inactive': '停用',
  'pages.question.categories.action.edit': '编辑',
  'pages.question.categories.action.delete': '删除',
  'pages.question.categories.delete.confirm': '确认删除该分类？',
  'pages.question.categories.delete.success': '分类已删除',
  'pages.question.categories.delete.failed': '删除分类失败，请稍后再试。',
  'pages.question.categories.empty': '还没有分类',
  'pages.question.categories.modal.add.title': '新增分类',
  'pages.question.categories.modal.edit.title': '编辑分类',
  'pages.question.categories.field.name': '分类名称',
  'pages.question.categories.field.name.required': '请输入分类名称',
  'pages.question.categories.field.name.placeholder': '输入分类名称',
  'pages.question.categories.field.code': '分类编码',
  'pages.question.categories.field.code.required': '请输入分类编码',
  'pages.question.categories.field.code.placeholder': '输入编码，建议使用英文',
  'pages.question.categories.field.code.pattern':
    '仅允许小写字母、数字、连字符和下划线',
  'pages.question.categories.field.description': '分类描述',
  'pages.question.categories.field.description.placeholder':
    '用于解释该分类的使用范围',
  'pages.question.categories.field.icon': '分类图标',
  'pages.question.categories.field.icon.placeholder': '图标名称或 URL',
  'pages.question.categories.field.sort': '排序值',
  'pages.question.categories.field.sort.placeholder': '数字越小越靠前',
  'pages.question.categories.field.parent': '父级分类',
  'pages.question.categories.field.parent.placeholder': '可选，选择父级分类',
  'pages.question.categories.field.active': '启用状态',
  'pages.question.categories.save.success': '分类已保存',
  'pages.question.categories.save.failed': '保存分类失败，请稍后再试。',
  'pages.question.categories.search.placeholder': '搜索分类名称或编码...',
  'pages.question.categories.refresh': '刷新',
  'pages.question.categories.total.prefix': '共',
  'pages.question.detail.title': '问题详情',
  'pages.question.detail.subtitle': '查看完整背景、最佳答案与团队点评。',
  'pages.question.detail.back': '返回列表',
  'pages.question.detail.load.failed': '加载问题详情失败。',
  'pages.question.detail.answers.load.failed': '加载回答列表失败，请稍后再试。',
  'pages.question.detail.answer.success': '回答已发布',
  'pages.question.detail.answer.failed': '发布回答失败，请稍后再试。',
  'pages.question.detail.comment.success': '评论已发布',
  'pages.question.detail.comment.failed': '发布评论失败，请稍后再试。',
  'pages.question.detail.interaction.failed': '操作失败，请稍后重试。',
  'pages.question.detail.best.confirm.title': '确认设为最佳答案？',
  'pages.question.detail.best.confirm.desc':
    '最佳答案会对所有人高亮展示，后续仍可调整。',
  'pages.question.detail.submit': '确认',
  'pages.question.detail.cancel': '取消',
  'pages.question.detail.best.success': '已设置为最佳答案',
  'pages.question.detail.best.failed': '设置最佳答案失败，请稍后再试。',
  'pages.question.detail.delete.success': '回答已删除',
  'pages.question.detail.delete.failed': '删除回答失败，请稍后再试。',
  'pages.question.detail.anonymous': '匿名用户',
  'pages.question.detail.reward.prefix': '奖励',
  'pages.question.detail.like': '点赞',
  'pages.question.detail.collect': '收藏',
  'pages.question.detail.answer': '我要回答',
  'pages.question.detail.ai.answer': 'AI 解答',
  'pages.question.detail.ai.answer.success': 'AI 草稿已生成，请先审核再提交。',
  'pages.question.detail.ai.answer.failed': '生成 AI 回答失败，请稍后重试。',
  'pages.question.detail.ai.answer.empty': '未获取到有效内容，请再试一次。',
  'pages.question.detail.not.found': '未找到相关问题',
  'pages.question.detail.answers.title': '回答',
  'pages.question.detail.answers.empty': '还没有人回答这个问题',
  'pages.question.detail.comment': '评论',
  'pages.question.detail.mark.best': '设为最佳',
  'pages.question.detail.best.badge': '最佳答案',
  'pages.question.detail.delete': '删除',
  'pages.question.detail.answer.modal.title': '写下你的回答',
  'pages.question.detail.field.content': '回答内容',
  'pages.question.detail.field.content.required': '请输入回答内容',
  'pages.question.detail.field.content.placeholder':
    '分享你的经验、方案与观点...',
  'pages.question.detail.field.anonymous': '匿名发布',
  'pages.question.detail.field.anonymous.label': '使用匿名身份',
  'pages.question.detail.comment.modal.title': '写下你的评论',
  'pages.question.detail.comment.field': '评论内容',
  'pages.question.detail.comment.field.required': '请输入评论内容',
  'pages.question.detail.comment.field.placeholder': '补充你的建议或继续追问',

  // analytic
  'pages.analytic.overview.title': '数据概览',
  'pages.analytic.overview.subtitle': '综合数据分析和业务趋势展示',
  'pages.analytic.loading': '加载分析数据中...',
  'pages.analytic.total.talents': '总人才数',
  'pages.analytic.total.jobs': '总职位数',
  'pages.analytic.total.clients': '总客户数',
  'pages.analytic.total.projects': '总项目数',
  'pages.analytic.time.range.week': '最近一周',
  'pages.analytic.time.range.month': '最近一月',
  'pages.analytic.time.range.quarter': '最近一季',
  'pages.analytic.time.range.year': '最近一年',
  'pages.analytic.refresh': '刷新',
  'pages.analytic.export.report': '导出报告',
  'pages.analytic.project.success.rate': '项目成功率',
  'pages.analytic.average.cycle.time': '平均周期时间',
  'pages.analytic.day.unit': '天',
  'pages.analytic.average.cycle.time.desc': '从项目开始到完成的平均时间',
  'pages.analytic.projects.average.cycle.time': '平均周期时间',
  'pages.analytic.projects.average.cycle.time.desc':
    '从项目开始到完成的平均时间',
  'pages.analytic.data.trend.analysis': '数据趋势分析',
  'pages.analytic.success.rate.trend': '成功率趋势',
  'pages.analytic.success.rate': '成功率',
  'pages.analytic.jobs.title': '职位分析',
  'pages.analytic.jobs.subtitle': '职位数据统计和分布分析',
  'pages.analytic.jobs.total': '总职位数',
  'pages.analytic.jobs.active': '活跃职位',
  'pages.analytic.jobs.paused': '已暂停',
  'pages.analytic.jobs.closed': '已关闭',
  'pages.analytic.jobs.success.rate': '成功率',
  'pages.analytic.jobs.status.open': '进行中',
  'pages.analytic.jobs.status.paused': '已暂停',
  'pages.analytic.jobs.status.closed': '已关闭',
  'pages.analytic.jobs.status.draft': '草稿',
  'pages.analytic.jobs.status.distribution': '职位状态分布',
  'pages.analytic.jobs.industry.distribution': '行业分布 Top 10',
  'pages.analytic.jobs.priority.distribution': '优先级分布',
  'pages.analytic.jobs.location.distribution': '地点分布 Top 10',
  'pages.analytic.jobs.creation.trend': '职位创建与关闭趋势',
  'pages.analytic.jobs.new': '新增职位',
  'pages.analytic.jobs.top': '热门职位 Top 10',
  'pages.analytic.jobs.table.title': '职位名称',
  'pages.analytic.jobs.table.company': '公司',
  'pages.analytic.jobs.table.candidates': '候选人数量',
  'pages.analytic.jobs.table.success': '成功数量',
  'pages.analytic.jobs.table.created.at': '创建时间',
  'pages.analytic.jobs.loading': '加载中...',
  'pages.analytic.jobs.refresh': '刷新',
  'pages.analytic.jobs.export.report': '导出报告',
  'pages.analytic.jobs.time.range.week': '本周',
  'pages.analytic.jobs.time.range.month': '本月',
  'pages.analytic.jobs.time.range.quarter': '本季度',
  'pages.analytic.jobs.time.range.year': '本年',
  'pages.analytic.talents.title': '人才分析',
  'pages.analytic.talents.subtitle': '人才库数据统计和分布分析',
  'pages.analytic.talents.total': '总人才数',
  'pages.analytic.talents.active': '活跃人才',
  'pages.analytic.talents.average.experience': '平均工作年限',
  'pages.analytic.talents.blacklisted': '黑名单人才',
  'pages.analytic.talents.status.active': '活跃',
  'pages.analytic.talents.status.inactive': '非活跃',
  'pages.analytic.talents.status.blacklisted': '黑名单',
  'pages.analytic.talents.status.distribution': '人才状态分布',
  'pages.analytic.talents.source.distribution': '来源分布 Top 10',
  'pages.analytic.talents.experience.distribution': '工作年限分布',
  'pages.analytic.talents.location.distribution': '地点分布 Top 10',
  'pages.analytic.talents.growth.trend': '人才增长趋势',
  'pages.analytic.talents.new': '新增人才',
  'pages.analytic.talents.top.skills': '热门技能 Top 10',
  'pages.analytic.talents.no.skills': '暂无技能数据',
  'pages.analytic.year.unit': '年',
  'pages.analytic.clients.title': '客户分析',
  'pages.analytic.clients.subtitle': '客户数据统计和分布分析',
  'pages.analytic.clients.total': '总客户数',
  'pages.analytic.clients.active': '活跃客户',
  'pages.analytic.clients.vip': 'VIP客户',
  'pages.analytic.clients.avg.projects': '平均项目数',
  'pages.analytic.clients.level.s': 'S级',
  'pages.analytic.clients.level.a': 'A级',
  'pages.analytic.clients.level.b': 'B级',
  'pages.analytic.clients.level.c': 'C级',
  'pages.analytic.clients.level.d': 'D级',
  'pages.analytic.clients.level.distribution': '客户等级分布',
  'pages.analytic.clients.industry.distribution': '行业分布 Top 10',
  'pages.analytic.clients.growth.trend': '客户增长趋势',
  'pages.analytic.clients.new': '新增客户',
  'pages.analytic.clients.top.performance': 'Top客户表现',
  'pages.analytic.clients.table.company': '公司名称',
  'pages.analytic.clients.table.projects': '项目数量',
  'pages.analytic.clients.table.success': '成功项目',
  'pages.analytic.clients.table.revenue': '总收入',
  'pages.analytic.projects.title': '项目分析',
  'pages.analytic.projects.subtitle': '项目数据统计和进展分析',
  'pages.analytic.projects.total': '总项目数',
  'pages.analytic.projects.in.progress': '进行中',
  'pages.analytic.projects.completed': '已完成',
  'pages.analytic.projects.avg.cycle': '平均周期',
  'pages.analytic.projects.status.in.progress': '进行中',
  'pages.analytic.projects.status.completed': '已完成',
  'pages.analytic.projects.status.cancelled': '已取消',
  'pages.analytic.projects.status.pending': '待开始',
  'pages.analytic.projects.interview.passed': '通过',
  'pages.analytic.projects.interview.failed': '未通过',
  'pages.analytic.projects.interview.pending': '待定',
  'pages.analytic.projects.interview.pass.rate': '面试通过率',
  'pages.analytic.projects.success.rate': '成功率',
  'pages.analytic.projects.status.distribution': '项目状态分布',
  'pages.analytic.projects.interview.type.distribution': '面试类型分布',
  'pages.analytic.projects.interview.result.distribution': '面试结果分布',
  'pages.analytic.projects.creation.trend': '项目创建与完成趋势',
  'pages.analytic.projects.new': '新增项目',
  'pages.analytic.work.title': '工作分析',
  'pages.analytic.work.subtitle': '个人与团队工作效率洞察',
  'pages.analytic.work.load.error': '加载工作分析数据失败',
  'pages.analytic.work.tab.personal': '个人视角',
  'pages.analytic.work.tab.team': '团队视角',
  'pages.analytic.work.time.range.yesterday': '昨天',
  'pages.analytic.work.time.range.today': '今天',
  'pages.analytic.work.time.range.this.week': '本周',
  'pages.analytic.work.time.range.last.week': '上周',
  'pages.analytic.work.time.range.this.month': '本月',
  'pages.analytic.work.time.range.last.month': '上月',
  'pages.analytic.work.time.range.this.quarter': '本季度',
  'pages.analytic.work.time.range.last.quarter': '上季度',
  'pages.analytic.work.time.range.this.year': '本年',
  'pages.analytic.work.time.range.last.year': '上年',
  'pages.analytic.work.time.range.custom': '自定义',
  'pages.analytic.work.time.range.start.date': '开始日期',
  'pages.analytic.work.time.range.end.date': '结束日期',
  'pages.analytic.work.card.uploads': '上传简历',
  'pages.analytic.work.card.valid': '有效简历',
  'pages.analytic.work.card.views': '查看次数',
  'pages.analytic.work.card.submissions': '投递数',
  'pages.analytic.work.card.interviews': '面试数',
  'pages.analytic.work.card.offers': 'Offer 数',
  'pages.analytic.work.card.hires': '入职数',
  'pages.analytic.work.card.revenue': 'GMV（k）',
  'pages.analytic.work.funnel.title': '漏斗概览',
  'pages.analytic.work.stage': '阶段',
  'pages.analytic.work.stage.volume': '数量',
  'pages.analytic.work.stage.conversion': '转化率',
  'pages.analytic.work.stage.cycle': '平均周期',
  'pages.analytic.work.stage.upload': '上传',
  'pages.analytic.work.stage.valid': '有效',
  'pages.analytic.work.stage.submit': '投递',
  'pages.analytic.work.stage.interview': '面试',
  'pages.analytic.work.stage.offer': 'Offer',
  'pages.analytic.work.stage.hire': '入职',
  'pages.analytic.work.trend.title': '流程趋势',
  'pages.analytic.work.trend.day': '第',
  'pages.analytic.work.team.title': '团队排行',
  'pages.analytic.work.col.name': '姓名',
  'pages.analytic.work.col.role': '角色',
  'pages.analytic.work.col.uploads': '上传',
  'pages.analytic.work.col.submissions': '投递',
  'pages.analytic.work.col.interviews': '面试',
  'pages.analytic.work.col.offers': 'Offer',
  'pages.analytic.work.col.hires': '入职',
  'pages.analytic.work.col.conversion': '入职转化',
  'pages.analytic.work.col.revenue': '营收',
  'pages.analytic.work.personal.title': '目标与进展',
  'pages.analytic.work.goal.upload': '上传目标',
  'pages.analytic.work.goal.submit': '投递目标',
  'pages.analytic.work.goal.interview': '面试目标',
  'pages.analytic.work.goal.offer': 'Offer 目标',
  'pages.analytic.work.goal.hire': '入职目标',
  'pages.analytic.work.goal.tip': '当前 / 目标',
  'pages.analytic.work.alerts.title': '洞察与提醒',
  'pages.analytic.work.alert.slow.funnel': '面试周期高于团队基准',
  'pages.analytic.work.alert.slow.funnel.desc':
    '平均面试周期 3.1 天，高于目标 2.5 天，建议加快反馈与跟进。',
  'pages.analytic.work.alert.goal.gap': 'Offer 转化低于目标',
  'pages.analytic.work.alert.goal.gap.desc':
    'Offer→入职转化率 14%，目标 18%，关注候选人意向和包方案。',
  'pages.analytic.work.me': '我',
  'pages.analytic.work.role.consultant': '顾问',
  'pages.analytic.work.role.manager': '管理者',

  // daily
  'pages.daily.reports.today.title': '今日日报',
  'pages.daily.reports.all.title': '全部日报',
  'pages.daily.reports.all.subtitle': '查看和管理所有历史日报记录',
  'pages.daily.reports.loading': '加载日报中...',
  'pages.daily.reports.load.failed': '加载日报失败',
  'pages.daily.reports.auto.created': '日报已自动创建',
  'pages.daily.reports.create.failed': '创建日报失败',
  'pages.daily.reports.save.success': '保存成功',
  'pages.daily.reports.save.failed': '保存失败',
  'pages.daily.reports.submit.success': '提交成功',
  'pages.daily.reports.submit.failed': '提交失败',
  'pages.daily.reports.list.load.failed': '加载日报列表失败',
  'pages.daily.reports.detail.load.failed': '加载日报详情失败',
  'pages.daily.reports.delete.success': '删除成功',
  'pages.daily.reports.delete.failed': '删除失败',
  'pages.daily.reports.delete.confirm.title': '确认删除',
  'pages.daily.reports.delete.confirm.content': '确定要删除 {date} 的日报吗？',
  'pages.daily.reports.no.data': '暂无数据',
  'pages.daily.reports.date.format': 'YYYY年MM月DD日',
  'pages.daily.reports.status.draft': '草稿',
  'pages.daily.reports.status.submitted': '已提交',
  'pages.daily.reports.status.archived': '已归档',
  'pages.daily.reports.stat.jobs': '职位',
  'pages.daily.reports.stat.talents': '人才',
  'pages.daily.reports.stat.clients': '客户',
  'pages.daily.reports.stat.projects': '项目',
  'pages.daily.reports.stat.jobs.detail':
    '更新: {updated} | 访谈: {interviews}',
  'pages.daily.reports.stat.talents.detail':
    '沟通: {communications} | 推荐: {recommended}',
  'pages.daily.reports.stat.clients.detail':
    '沟通: {communications} | 访谈: {interviews}',
  'pages.daily.reports.stat.projects.detail':
    '推荐: {recommended} | 面试: {completed}',
  'pages.daily.reports.unit.count': '个',
  'pages.daily.reports.unit.person': '人',
  'pages.daily.reports.unit.article': '篇',
  'pages.daily.reports.unit.post': '条',
  'pages.daily.reports.questions.stats': '问师傅统计',
  'pages.daily.reports.questions.asked': '提问',
  'pages.daily.reports.questions.answered': '回答',
  'pages.daily.reports.articles': '文章',
  'pages.daily.reports.posts': '动态',
  'pages.daily.reports.work.content': '工作内容',
  'pages.daily.reports.auto.summary': '自动生成的摘要',
  'pages.daily.reports.no.summary': '暂无摘要',
  'pages.daily.reports.notes': '备注',
  'pages.daily.reports.notes.placeholder': '请补充今日工作备注...',
  'pages.daily.reports.save': '保存',
  'pages.daily.reports.submit': '提交',
  'pages.daily.reports.view.all': '查看全部日报',
  'pages.daily.reports.column.date': '日期',
  'pages.daily.reports.column.status': '状态',
  'pages.daily.reports.column.stats': '统计数据',
  'pages.daily.reports.column.summary': '摘要',
  'pages.daily.reports.column.creator': '创建人',
  'pages.daily.reports.column.actions': '操作',
  'pages.daily.reports.action.view': '查看',
  'pages.daily.reports.action.edit': '编辑',
  'pages.daily.reports.action.delete': '删除',
  'pages.daily.reports.search.placeholder': '搜索摘要',
  'pages.daily.reports.date.start': '开始日期',
  'pages.daily.reports.date.end': '结束日期',
  'pages.daily.reports.status.filter': '状态',
  'pages.daily.reports.table.total': '共 {total} 条',
  'pages.daily.reports.detail.title': '日报详情',
  'pages.daily.reports.detail.stats': '统计数据',
  'pages.daily.reports.close': '关闭',
  'pages.daily.reports.today.button': '今日日报',

  // weekly
  'pages.weekly.reports.this.week.title': '本周周报',
  'pages.weekly.reports.all.title': '全部周报',
  'pages.weekly.reports.all.subtitle': '查看和管理所有历史周报记录',
  'pages.weekly.reports.loading': '加载周报中...',
  'pages.weekly.reports.load.failed': '加载周报失败',
  'pages.weekly.reports.auto.created': '周报已自动创建',
  'pages.weekly.reports.create.failed': '创建周报失败',
  'pages.weekly.reports.save.success': '保存成功',
  'pages.weekly.reports.save.failed': '保存失败',
  'pages.weekly.reports.submit.success': '提交成功',
  'pages.weekly.reports.submit.failed': '提交失败',
  'pages.weekly.reports.list.load.failed': '加载周报列表失败',
  'pages.weekly.reports.detail.load.failed': '加载周报详情失败',
  'pages.weekly.reports.delete.success': '删除成功',
  'pages.weekly.reports.delete.failed': '删除失败',
  'pages.weekly.reports.delete.confirm.title': '确认删除',
  'pages.weekly.reports.delete.confirm.content':
    '确定要删除 {year}年第{week}周 的周报吗？',
  'pages.weekly.reports.no.data': '暂无数据',
  'pages.weekly.reports.week.format': '{year}年第{week}周',
  'pages.weekly.reports.week.format.short': '第{week}周',
  'pages.weekly.reports.status.draft': '草稿',
  'pages.weekly.reports.status.submitted': '已提交',
  'pages.weekly.reports.status.archived': '已归档',
  'pages.weekly.reports.stat.jobs': '职位',
  'pages.weekly.reports.stat.talents': '人才',
  'pages.weekly.reports.stat.clients': '客户',
  'pages.weekly.reports.stat.projects': '项目',
  'pages.weekly.reports.stat.jobs.detail':
    '更新: {updated} | 访谈: {interviews}',
  'pages.weekly.reports.stat.talents.detail':
    '沟通: {communications} | 推荐: {recommended}',
  'pages.weekly.reports.stat.clients.detail':
    '沟通: {communications} | 访谈: {interviews}',
  'pages.weekly.reports.stat.projects.detail':
    '推荐: {recommended} | 面试: {completed}',
  'pages.weekly.reports.unit.count': '个',
  'pages.weekly.reports.unit.person': '人',
  'pages.weekly.reports.unit.article': '篇',
  'pages.weekly.reports.unit.post': '条',
  'pages.weekly.reports.questions.stats': '问师傅统计',
  'pages.weekly.reports.questions.asked': '提问',
  'pages.weekly.reports.questions.answered': '回答',
  'pages.weekly.reports.articles': '文章',
  'pages.weekly.reports.posts': '动态',
  'pages.weekly.reports.content': '周报内容',
  'pages.weekly.reports.auto.summary': '自动生成的周工作总结',
  'pages.weekly.reports.autoSummary': '自动生成的周工作总结',
  'pages.weekly.reports.no.summary': '暂无摘要',
  'pages.weekly.reports.noSummary': '暂无摘要',
  'pages.weekly.reports.weekly.summary': '周工作总结',
  'pages.weekly.reports.weeklySummary': '周工作总结',
  'pages.weekly.reports.weekly.summary.placeholder': '请填写本周工作总结...',
  'pages.weekly.reports.weeklySummary.placeholder': '请填写本周工作总结...',
  'pages.weekly.reports.key.achievements': '关键成果',
  'pages.weekly.reports.keyAchievements': '关键成果',
  'pages.weekly.reports.key.achievements.placeholder': '请填写本周关键成果...',
  'pages.weekly.reports.keyAchievements.placeholder': '请填写本周关键成果...',
  'pages.weekly.reports.challenges': '挑战',
  'pages.weekly.reports.challenges.placeholder': '请填写遇到的挑战...',
  'pages.weekly.reports.next.week.plan': '下周计划',
  'pages.weekly.reports.nextWeekPlan': '下周计划',
  'pages.weekly.reports.next.week.plan.placeholder': '请填写下周计划...',
  'pages.weekly.reports.nextWeekPlan.placeholder': '请填写下周计划...',
  'pages.weekly.reports.save': '保存',
  'pages.weekly.reports.submit': '提交',
  'pages.weekly.reports.view.all': '查看全部周报',
  'pages.weekly.reports.viewAll': '查看全部周报',
  'pages.weekly.reports.column.year': '年份',
  'pages.weekly.reports.column.week': '周数',
  'pages.weekly.reports.column.period': '周期',
  'pages.weekly.reports.column.status': '状态',
  'pages.weekly.reports.column.stats': '统计数据',
  'pages.weekly.reports.column.summary': '摘要',
  'pages.weekly.reports.column.actions': '操作',
  'pages.weekly.reports.action.view': '查看',
  'pages.weekly.reports.action.edit': '编辑',
  'pages.weekly.reports.action.delete': '删除',
  'pages.weekly.reports.year.filter': '年份',
  'pages.weekly.reports.status.filter': '状态',
  'pages.weekly.reports.table.total': '共 {total} 条',
  'pages.weekly.reports.detail.title': '周报详情',
  'pages.weekly.reports.detail.stats': '统计数据',
  'pages.weekly.reports.close': '关闭',
  'pages.weekly.reports.this.week.button': '本周周报',

  // monthly
  'pages.monthly.reports.this.month.title': '本月月报',
  'pages.monthly.reports.all.title': '全部月报',
  'pages.monthly.reports.all.subtitle': '查看和管理所有历史月报记录',
  'pages.monthly.reports.loading': '加载月报中...',
  'pages.monthly.reports.load.failed': '加载月报失败',
  'pages.monthly.reports.auto.created': '月报已自动创建',
  'pages.monthly.reports.create.failed': '创建月报失败',
  'pages.monthly.reports.save.success': '保存成功',
  'pages.monthly.reports.save.failed': '保存失败',
  'pages.monthly.reports.submit.success': '提交成功',
  'pages.monthly.reports.submit.failed': '提交失败',
  'pages.monthly.reports.list.load.failed': '加载月报列表失败',
  'pages.monthly.reports.detail.load.failed': '加载月报详情失败',
  'pages.monthly.reports.delete.success': '删除成功',
  'pages.monthly.reports.delete.failed': '删除失败',
  'pages.monthly.reports.delete.confirm.title': '确认删除',
  'pages.monthly.reports.delete.confirm.content':
    '确定要删除 {year}年{month}月 的月报吗？',
  'pages.monthly.reports.no.data': '暂无数据',
  'pages.monthly.reports.month.format': '{year}年{month}月',
  'pages.monthly.reports.month.format.short': '{month}月',
  'pages.monthly.reports.status.draft': '草稿',
  'pages.monthly.reports.status.submitted': '已提交',
  'pages.monthly.reports.status.archived': '已归档',
  'pages.monthly.reports.stat.jobs': '职位',
  'pages.monthly.reports.stat.talents': '人才',
  'pages.monthly.reports.stat.clients': '客户',
  'pages.monthly.reports.stat.projects': '项目',
  'pages.monthly.reports.stat.jobs.detail':
    '更新: {updated} | 访谈: {interviews}',
  'pages.monthly.reports.stat.talents.detail':
    '沟通: {communications} | 推荐: {recommended}',
  'pages.monthly.reports.stat.clients.detail':
    '沟通: {communications} | 访谈: {interviews}',
  'pages.monthly.reports.stat.projects.detail':
    '完成: {completed} | 成功: {successful}',
  'pages.monthly.reports.unit.count': '个',
  'pages.monthly.reports.unit.person': '人',
  'pages.monthly.reports.revenue': '月收入',
  'pages.monthly.reports.projects.completed': '完成项目',
  'pages.monthly.reports.projects.successful': '成功项目',
  'pages.monthly.reports.content': '月报内容',
  'pages.monthly.reports.auto.summary': '自动生成的月工作总结',
  'pages.monthly.reports.no.summary': '暂无摘要',
  'pages.monthly.reports.monthly.summary': '月工作总结',
  'pages.monthly.reports.monthly.summary.placeholder': '请填写本月工作总结...',
  'pages.monthly.reports.key.achievements': '关键成果',
  'pages.monthly.reports.key.achievements.placeholder': '请填写本月关键成果...',
  'pages.monthly.reports.important.projects': '重要项目',
  'pages.monthly.reports.important.projects.placeholder':
    '请填写本月重要项目...',
  'pages.monthly.reports.important.clients': '重要客户',
  'pages.monthly.reports.important.clients.placeholder':
    '请填写本月重要客户...',
  'pages.monthly.reports.challenges': '遇到的挑战',
  'pages.monthly.reports.challenges.placeholder': '请填写本月遇到的挑战...',
  'pages.monthly.reports.next.month.plan': '下月计划',
  'pages.monthly.reports.next.month.plan.placeholder': '请填写下月计划...',
  'pages.monthly.reports.goal.completion': '目标完成度',
  'pages.monthly.reports.save': '保存',
  'pages.monthly.reports.submit': '提交',
  'pages.monthly.reports.view.all': '查看全部月报',
  'pages.monthly.reports.column.year': '年份',
  'pages.monthly.reports.column.month': '月份',
  'pages.monthly.reports.column.period': '周期',
  'pages.monthly.reports.column.status': '状态',
  'pages.monthly.reports.column.stats': '统计数据',
  'pages.monthly.reports.column.revenue': '收入',
  'pages.monthly.reports.column.summary': '摘要',
  'pages.monthly.reports.column.actions': '操作',
  'pages.monthly.reports.action.view': '查看',
  'pages.monthly.reports.action.edit': '编辑',
  'pages.monthly.reports.action.delete': '删除',
  'pages.monthly.reports.year.filter': '年份',
  'pages.monthly.reports.month.filter': '月份',
  'pages.monthly.reports.status.filter': '状态',
  'pages.monthly.reports.table.total': '共 {total} 条',
  'pages.monthly.reports.detail.title': '月报详情',
  'pages.monthly.reports.detail.stats': '统计数据',
  'pages.monthly.reports.close': '关闭',
  'pages.monthly.reports.this.month.button': '本月月报',

  // yearly
  'pages.yearly.reports.this.year.title': '本年年报',
  'pages.yearly.reports.all.title': '全部年报',
  'pages.yearly.reports.all.subtitle': '查看和管理所有历史年报记录',
  'pages.yearly.reports.loading': '加载年报中...',
  'pages.yearly.reports.load.failed': '加载年报失败',
  'pages.yearly.reports.auto.created': '年报已自动创建',
  'pages.yearly.reports.create.failed': '创建年报失败',
  'pages.yearly.reports.save.success': '保存成功',
  'pages.yearly.reports.save.failed': '保存失败',
  'pages.yearly.reports.submit.success': '提交成功',
  'pages.yearly.reports.submit.failed': '提交失败',
  'pages.yearly.reports.list.load.failed': '加载年报列表失败',
  'pages.yearly.reports.detail.load.failed': '加载年报详情失败',
  'pages.yearly.reports.delete.success': '删除成功',
  'pages.yearly.reports.delete.failed': '删除失败',
  'pages.yearly.reports.delete.confirm.title': '确认删除',
  'pages.yearly.reports.delete.confirm.content':
    '确定要删除 {year}年 的年报吗？',
  'pages.yearly.reports.no.data': '暂无数据',
  'pages.yearly.reports.year.format': '{year}年',
  'pages.yearly.reports.status.draft': '草稿',
  'pages.yearly.reports.status.submitted': '已提交',
  'pages.yearly.reports.status.archived': '已归档',
  'pages.yearly.reports.stat.jobs': '职位',
  'pages.yearly.reports.stat.talents': '人才',
  'pages.yearly.reports.stat.clients': '客户',
  'pages.yearly.reports.stat.projects': '项目',
  'pages.yearly.reports.stat.jobs.detail':
    '更新: {updated} | 访谈: {interviews}',
  'pages.yearly.reports.stat.talents.detail':
    '沟通: {communications} | 推荐: {recommended}',
  'pages.yearly.reports.stat.clients.detail':
    '沟通: {communications} | 访谈: {interviews}',
  'pages.yearly.reports.stat.projects.detail':
    '完成: {completed} | 成功: {successful}',
  'pages.yearly.reports.unit.count': '个',
  'pages.yearly.reports.unit.person': '人',
  'pages.yearly.reports.revenue': '年收入',
  'pages.yearly.reports.projects.completed': '完成项目',
  'pages.yearly.reports.projects.successful': '成功项目',
  'pages.yearly.reports.content': '年报内容',
  'pages.yearly.reports.auto.summary': '自动生成的年工作总结',
  'pages.yearly.reports.no.summary': '暂无摘要',
  'pages.yearly.reports.yearly.summary': '年工作总结',
  'pages.yearly.reports.yearly.summary.placeholder': '请填写本年度工作总结...',
  'pages.yearly.reports.key.achievements': '关键成果',
  'pages.yearly.reports.key.achievements.placeholder':
    '请填写本年度关键成果...',
  'pages.yearly.reports.important.projects': '重要项目',
  'pages.yearly.reports.important.projects.placeholder':
    '请填写本年度重要项目...',
  'pages.yearly.reports.important.clients': '重要客户',
  'pages.yearly.reports.important.clients.placeholder':
    '请填写本年度重要客户...',
  'pages.yearly.reports.milestones': '里程碑',
  'pages.yearly.reports.milestones.placeholder': '请填写本年度里程碑...',
  'pages.yearly.reports.challenges': '遇到的挑战',
  'pages.yearly.reports.challenges.placeholder': '请填写本年度遇到的挑战...',
  'pages.yearly.reports.solutions': '解决方案',
  'pages.yearly.reports.solutions.placeholder': '请填写解决方案...',
  'pages.yearly.reports.growth': '成长',
  'pages.yearly.reports.growth.placeholder': '请填写您的成长...',
  'pages.yearly.reports.next.year.plan': '下年计划',
  'pages.yearly.reports.next.year.plan.placeholder': '请输入明年计划',
  'pages.yearly.reports.goal.completion': '目标完成度',
  'pages.yearly.reports.save': '保存',
  'pages.yearly.reports.submit': '提交',
  'pages.yearly.reports.view.all': '查看全部年报',
  'pages.yearly.reports.column.year': '年份',
  'pages.yearly.reports.column.period': '周期',
  'pages.yearly.reports.column.status': '状态',
  'pages.yearly.reports.column.stats': '统计数据',
  'pages.yearly.reports.column.revenue': '收入',
  'pages.yearly.reports.column.summary': '摘要',
  'pages.yearly.reports.column.actions': '操作',
  'pages.yearly.reports.action.view': '查看',
  'pages.yearly.reports.action.edit': '编辑',
  'pages.yearly.reports.action.delete': '删除',
  'pages.yearly.reports.year.filter': '年份',
  'pages.yearly.reports.status.filter': '状态',
  'pages.yearly.reports.table.total': '共 {total} 条',
  'pages.yearly.reports.detail.title': '年报详情',
  'pages.yearly.reports.detail.stats': '统计数据',
  'pages.yearly.reports.close': '关闭',
  'pages.yearly.reports.this.year.button': '本年年报',

  // data
  'pages.data.dict.title': '数据字典',
  'pages.data.dict.subtitle': '维护通用表单的类别与选项，统一复用。',
  'pages.data.dict.refresh': '刷新',
  'pages.data.dict.add.category': '新增类别',
  'pages.data.dict.add.item': '新增选项',
  'pages.data.dict.edit.category.title': '编辑类别',
  'pages.data.dict.add.category.title': '新增类别',
  'pages.data.dict.edit.item.title': '编辑选项',
  'pages.data.dict.add.item.title': '新增选项',
  'pages.data.dict.form.name': '名称',
  'pages.data.dict.form.name.required': '请输入名称',
  'pages.data.dict.form.code': '编码',
  'pages.data.dict.form.code.required': '请输入编码',
  'pages.data.dict.form.description': '描述',
  'pages.data.dict.form.parent': '父级 UUID',
  'pages.data.dict.form.parent.placeholder': '可填父级类别 UUID（可选）',
  'pages.data.dict.form.sort': '排序',
  'pages.data.dict.form.active': '启用',
  'pages.data.dict.item.form.category': '所属类别',
  'pages.data.dict.item.form.parent': '父级选项',
  'pages.data.dict.item.form.parent.placeholder': '选择父级选项（可选）',
  'pages.data.dict.item.form.parent.tooltip': '选择父级选项以创建树形结构',
  'pages.data.dict.item.form.label': '显示名称',
  'pages.data.dict.item.form.label.required': '请输入显示名称',
  'pages.data.dict.item.form.value': '选项值',
  'pages.data.dict.item.form.value.required': '请输入选项值',
  'pages.data.dict.item.form.description': '描述',
  'pages.data.dict.item.form.sort': '排序',
  'pages.data.dict.item.form.default': '默认选项',
  'pages.data.dict.item.form.active': '启用',
  'pages.data.dict.column.name': '名称',
  'pages.data.dict.column.code': '编码',
  'pages.data.dict.column.sort': '排序',
  'pages.data.dict.column.count': '选项数',
  'pages.data.dict.column.status': '状态',
  'pages.data.dict.column.actions': '操作',
  'pages.data.dict.item.column.label': '名称',
  'pages.data.dict.item.column.value': '值',
  'pages.data.dict.item.column.description': '描述',
  'pages.data.dict.item.column.sort': '排序',
  'pages.data.dict.item.column.default': '默认',
  'pages.data.dict.item.column.status': '状态',
  'pages.data.dict.item.column.actions': '操作',
  'pages.data.dict.status.active': '已启用',
  'pages.data.dict.status.inactive': '未启用',
  'pages.data.dict.action.edit': '编辑',
  'pages.data.dict.action.add.child': '添加下级选项',
  'pages.data.dict.action.delete': '删除',
  'pages.data.dict.confirm': '确定',
  'pages.data.dict.cancel': '取消',
  'pages.data.dict.delete.category.confirm':
    '确定删除该类别？删除前需清空选项。',
  'pages.data.dict.delete.item.confirm': '确定删除该选项？',
  'pages.data.dict.save.success': '保存成功',
  'pages.data.dict.save.failed': '保存失败，请重试',
  'pages.data.dict.delete.success': '删除成功',
  'pages.data.dict.delete.failed': '删除失败，请重试',
  'pages.data.dict.load.categories.failed': '加载类别失败',
  'pages.data.dict.load.items.failed': '加载选项失败',
  'pages.data.dict.categories': '类别列表',
  'pages.data.dict.items.title': '选项 - {category}',
  'pages.data.dict.select.category.first': '请先选择类别',
  'pages.data.dict.search.placeholder': '按名称或编码搜索',
  'pages.data.dict.flag.yes': '是',
  'pages.data.dict.flag.no': '否',

  // personal
  'pages.personal.settings.title': '个人设置',
  'pages.personal.settings.subtitle':
    '管理猎头个人信息，包括头像、姓名、职务、联系方式等。',
  'pages.personal.settings.save.success': '设置已保存',
  'pages.personal.settings.save.failed': '保存失败，请稍后重试',
  'pages.personal.settings.avatar.updated': '头像已更新',
  'pages.personal.settings.avatar.upload.failed': '头像上传失败，请稍后重试',
  'pages.personal.settings.section.personal': '个人信息',
  'pages.personal.settings.section.system': '系统偏好',
  'pages.personal.settings.section.notifications': '通知设置',
  'pages.personal.settings.section.security': '安全与隐私',
  'pages.personal.settings.change.avatar': '更换头像',
  'pages.personal.settings.avatar.tip': '建议尺寸 256×256px，支持 JPG/PNG',
  'pages.personal.settings.name': '姓名',
  'pages.personal.settings.name.required': '请输入姓名',
  'pages.personal.settings.name.placeholder': '请输入姓名',
  'pages.personal.settings.position': '职务',
  'pages.personal.settings.position.required': '请输入职务',
  'pages.personal.settings.position.placeholder': '例如 高级猎头顾问',
  'pages.personal.settings.email': '邮箱',
  'pages.personal.settings.email.required': '请输入邮箱',
  'pages.personal.settings.email.invalid': '请输入合法邮箱',
  'pages.personal.settings.email.placeholder': 'name@company.com',
  'pages.personal.settings.phone': '手机号',
  'pages.personal.settings.phone.required': '请输入手机号',
  'pages.personal.settings.phone.placeholder': '请输入手机号',
  'pages.personal.settings.company': '所属公司',
  'pages.personal.settings.company.required': '请输入公司名称',
  'pages.personal.settings.company.placeholder': '请输入公司名称',
  'pages.personal.settings.signature': '个性签名',
  'pages.personal.settings.signature.placeholder':
    '可用于报告或简介的个性签名...',
  'pages.personal.settings.language': '界面语言',
  'pages.personal.settings.language.required': '请选择语言',
  'pages.personal.settings.language.placeholder': '请选择界面语言',
  'pages.personal.settings.language.zh': '简体中文',
  'pages.personal.settings.language.en': 'English',
  'pages.personal.settings.timezone': '时区',
  'pages.personal.settings.timezone.required': '请选择时区',
  'pages.personal.settings.timezone.placeholder': '请选择时区',
  'pages.personal.settings.data.retention': '数据保留天数',
  'pages.personal.settings.data.retention.required': '请输入数据保留天数',
  'pages.personal.settings.data.retention.placeholder': '请输入天数',
  'pages.personal.settings.days': '天',
  'pages.personal.settings.minutes': '分钟',
  'pages.personal.settings.auto.backup': '自动备份',
  'pages.personal.settings.email.notifications': '邮件通知',
  'pages.personal.settings.sms.notifications': '短信通知',
  'pages.personal.settings.weekly.report': '周报提醒',
  'pages.personal.settings.notification.time': '提醒时间',
  'pages.personal.settings.notification.time.placeholder': '请选择提醒时间',
  'pages.personal.settings.report.day': '提交日',
  'pages.personal.settings.report.day.placeholder': '请选择一周中的一天',
  'pages.personal.settings.monday': '周一',
  'pages.personal.settings.tuesday': '周二',
  'pages.personal.settings.wednesday': '周三',
  'pages.personal.settings.thursday': '周四',
  'pages.personal.settings.friday': '周五',
  'pages.personal.settings.two.factor': '双重验证',
  'pages.personal.settings.login.alerts': '登录提醒',
  'pages.personal.settings.session.timeout': '会话超时时间',
  'pages.personal.settings.session.timeout.placeholder': '请选择超时时长',
  'pages.personal.settings.password.expiry': '密码有效期',
  'pages.personal.settings.password.expiry.placeholder': '请选择有效期策略',
  'pages.personal.settings.never.expire': '永不过期',
  'pages.personal.settings.change.password': '修改密码',
  'pages.personal.settings.delete.account': '删除账号',
  'pages.personal.settings.save.button': '保存设置',

  // message
  'pages.message.title': '消息中心',
  'pages.message.unread.tip': '有 {count} 条未读消息',
  'pages.message.no.unread': '暂无未读消息',
  'pages.message.mark.all': '全部标记为已读',
  'pages.message.tab.all': '全部',
  'pages.message.tab.job': '职位',
  'pages.message.tab.talent': '人才',
  'pages.message.tab.client': '客户',
  'pages.message.tab.project': '项目',
  'pages.message.tab.system': '系统',
  'pages.message.tab.reminder': '提醒',
  'pages.message.load.failed': '加载消息失败',
  'pages.message.mark.failed': '操作失败',
  'pages.message.mark.all.success': '已全部标记为已读',
  'pages.message.delete.success': '删除成功',
  'pages.message.delete.failed': '删除失败',
  'pages.message.empty': '暂无消息',
  'pages.message.mark.read': '标记已读',
  'pages.message.delete': '删除',
  'pages.message.total.text': '第 {start}-{end} 条 / 共 {total} 条',
  'pages.message.category.info': '信息',
  'pages.message.category.warning': '警告',
  'pages.message.category.error': '错误',
  'pages.message.category.success': '成功',
  'pages.message.priority.urgent': '紧急',
  'pages.message.priority.high': '高',
  'pages.message.priority.normal': '普通',
  'pages.message.priority.low': '低',
  'pages.message.priority.badge': '紧急',
  'pages.message.type.job': '职位',
  'pages.message.type.talent': '人才',
  'pages.message.type.client': '客户',
  'pages.message.type.project': '项目',
  'pages.message.type.system': '系统',
  'pages.message.type.reminder': '提醒',

  // report
  'pages.report.templates.title': '推荐报告模板管理',
  'pages.report.templates.subtitle': '创建并管理可重复使用的推荐报告模板。',
  'pages.report.templates.load.failed': '加载模板失败',
  'pages.report.templates.attachment.load.failed': '加载附件失败',
  'pages.report.templates.update.success': '模板更新成功',
  'pages.report.templates.create.success': '模板创建成功',
  'pages.report.templates.save.failed': '保存模板失败',
  'pages.report.templates.delete.success': '模板删除成功',
  'pages.report.templates.delete.failed': '删除模板失败',
  'pages.report.templates.duplicate.success': '模板复制成功',
  'pages.report.templates.duplicate.failed': '复制模板失败',
  'pages.report.templates.set.default.success': '默认模板设置成功',
  'pages.report.templates.set.default.failed': '设置默认模板失败',
  'pages.report.templates.attachment.delete.success': '附件删除成功',
  'pages.report.templates.attachment.delete.failed': '删除附件失败',
  'pages.report.templates.attachment.upload.success': '附件上传成功',
  'pages.report.templates.attachment.upload.failed': '上传附件失败',
  'pages.report.templates.file.too.large': '文件大小不能超过 100MB',
  'pages.report.templates.default': '默认',
  'pages.report.templates.has.description': '（含描述）',
  'pages.report.templates.no.attachments': '暂无附件',
  'pages.report.templates.download': '下载',
  'pages.report.templates.download.all': '下载全部',
  'pages.report.templates.attachment.count': '共 {count} 个附件',
  'pages.report.templates.column.name': '模板名称',
  'pages.report.templates.column.attachments': '附件',
  'pages.report.templates.column.created': '创建时间',
  'pages.report.templates.column.actions': '操作',
  'pages.report.templates.action.edit': '编辑',
  'pages.report.templates.action.duplicate': '复制',
  'pages.report.templates.action.set.default': '设为默认',
  'pages.report.templates.action.delete': '删除',
  'pages.report.templates.delete.confirm': '确定要删除该模板吗？',
  'pages.report.templates.confirm': '确定',
  'pages.report.templates.cancel': '取消',
  'pages.report.templates.search.placeholder': '搜索模板名称',
  'pages.report.templates.create': '新增模板',
  'pages.report.templates.table.total': '第 {start}-{end} 条 / 共 {total} 条',
  'pages.report.templates.modal.edit': '编辑模板',
  'pages.report.templates.modal.create': '创建模板',
  'pages.report.templates.modal.save': '保存',
  'pages.report.templates.field.name': '模板名称',
  'pages.report.templates.field.name.required': '请输入模板名称',
  'pages.report.templates.field.name.placeholder': '请输入模板名称',
  'pages.report.templates.field.description': '模板描述',
  'pages.report.templates.field.description.placeholder': '请输入模板描述',
  'pages.report.templates.existing.attachments': '已有附件',
  'pages.report.templates.view': '预览',
  'pages.report.templates.attachment.delete.confirm': '确定要删除该附件吗？',
  'pages.report.templates.delete': '删除',
  'pages.report.templates.upload.new': '上传新附件',
  'pages.report.templates.upload.file': '模板文件',
  'pages.report.templates.upload.hint': '点击或拖拽文件到此上传',
  'pages.report.templates.upload.desc':
    '支持 PDF、DOC、DOCX、TXT、HTML 等格式，最大 100MB。',
  'pages.report.templates.field.default': '默认模板',
  'pages.report.templates.upload.mode': '上传方式',
  'pages.report.templates.upload.mode.file': '上传文件',
  'pages.report.templates.upload.mode.link': '使用链接',
  'pages.report.templates.link.url': '模板链接',
  'pages.report.templates.link.url.placeholder': '请输入模板文件链接地址',
  'pages.report.templates.link.url.hint': '输入有效的链接地址以下载模板文件',
  'pages.report.templates.download.link': '下载模板',
  'pages.report.templates.download.link.loading': '正在下载...',
  'pages.report.templates.download.link.success': '模板下载成功，请编辑后上传',
  'pages.report.templates.download.link.failed': '从链接下载模板失败',
  'pages.report.templates.link.invalid': '请输入有效的链接地址',
  'pages.report.templates.link.hint': '输入模板文件链接，下载后编辑，然后上传',
  'pages.report.templates.download.template': '从链接下载模板',
  'pages.report.templates.download.template.desc':
    '点击按钮下载模板文件，编辑后上传',

  // search
  'pages.search.title': '搜索',
  'pages.search.subtitle': '搜索问题、文章、动态、话题和用户',
  'pages.search.placeholder': '输入关键词搜索...',
  'pages.search.please.enter.keyword': '请输入搜索关键词',
  'pages.search.search.failed': '搜索失败，请稍后重试',
  'pages.search.no.results': '暂无搜索结果',
  'pages.search.filter.all': '全部',
  'pages.search.filter.questions': '问题',
  'pages.search.filter.articles': '文章',
  'pages.search.filter.posts': '动态',
  'pages.search.filter.topics': '话题',
  'pages.search.sort.relevance': '相关度',
  'pages.search.sort.latest': '最新',
  'pages.search.sort.hot': '热门',
  'pages.search.tab.all': '全部',
  'pages.search.tab.questions': '问题',
  'pages.search.tab.articles': '文章',
  'pages.search.tab.posts': '动态',
  'pages.search.tab.topics': '话题',
  'pages.search.uncategorized': '未分类',
  'pages.search.answers': '回答',
  'pages.search.paid': '付费',
  'pages.search.images': '张',
  'pages.search.followers': '关注',
  'pages.search.questions': '问题',
  'pages.search.articles': '文章',
  'pages.search.official': '官方',

  // feed
  'pages.feed.title': '问师傅',
  'pages.feed.subtitle': '发现精彩内容，与同行交流学习',
  'pages.feed.load.failed': '加载失败',
  'pages.feed.no.content': '暂无内容',
  'pages.feed.no.more': '没有更多了',
  'pages.feed.publish.post': '发布动态',
  'pages.feed.post.modal.coming.soon': '发布动态功能即将上线',
  'pages.feed.recommended': '为你推荐',
  'pages.feed.latest': '最新',
  'pages.feed.hot': '热门',
  'pages.feed.following': '关注',
  'pages.feed.anonymous.user': '匿名用户',
  'pages.feed.unknown.user': '未知用户',
  'pages.feed.answered.question': '回答了问题',
  'pages.feed.best.answer': '最佳答案',
  'pages.feed.article': '文章',
  'pages.feed.paid': '付费',
  'pages.feed.post': '动态',
  'pages.feed.image': '图片',
  'pages.feed.answers': '回答',
  'pages.feed.share': '分享',

  // article
  'pages.article.title': '文章',
  'pages.article.subtitle': '专业文章分享，深度内容解读',
  'pages.article.load.failed': '加载失败',
  'pages.article.write.article': '写文章',
  'pages.article.create.coming.soon': '写文章功能即将上线',
  'pages.article.search.placeholder': '搜索文章...',
  'pages.article.sort.latest': '最新发布',
  'pages.article.sort.hot': '最热文章',
  'pages.article.sort.read': '最多阅读',
  'pages.article.total': '共 {total} 篇文章',
  'pages.article.paid': '付费',
  'pages.article.featured': '精选',
  'pages.article.top': '置顶',
  'pages.article.detail.load.failed': '加载失败',
  'pages.article.detail.operation.failed': '操作失败',
  'pages.article.detail.not.found': '文章不存在',
  'pages.article.detail.back.to.list': '← 返回文章列表',
  'pages.article.detail.anonymous.user': '匿名用户',
  'pages.article.detail.unknown.user': '未知用户',
  'pages.article.detail.paid.article': '付费文章',
  'pages.article.detail.featured': '精选',
  'pages.article.detail.top': '置顶',
  'pages.article.detail.published.at': '发布于',
  'pages.article.detail.purchase.title': '购买文章',
  'pages.article.detail.purchase.content':
    '确定要花费 {price} 积分购买这篇文章吗？',
  'pages.article.detail.purchase.success': '购买成功',
  'pages.article.detail.purchase.failed': '购买失败',
  'pages.article.detail.purchase.now': '立即购买',
  'pages.article.detail.paid.notice':
    '这是一篇付费文章，需要花费 {price} 积分阅读',
  'pages.article.detail.collect': '收藏',
  'pages.article.detail.comment': '评论',
  'pages.article.detail.share': '分享',
  'pages.article.detail.read': '阅读',
  'pages.article.detail.comments': '评论',
  'pages.article.detail.comment.placeholder': '写下你的评论...',
  'pages.article.detail.submit.comment': '发表评论',
  'pages.article.detail.comment.success': '评论成功',
  'pages.article.detail.comment.failed': '评论失败',

  // topic
  'pages.topic.title': '话题',
  'pages.topic.subtitle': '发现感兴趣的话题，关注你感兴趣的内容',
  'pages.topic.load.failed': '加载失败',
  'pages.topic.search.placeholder': '搜索话题...',
  'pages.topic.tab.all': '全部话题',
  'pages.topic.tab.hot': '热门话题',
  'pages.topic.tab.recommended': '推荐话题',
  'pages.topic.followers': '关注',
  'pages.topic.questions': '问题',
  'pages.topic.articles': '文章',
  'pages.topic.official': '官方',
  'pages.topic.no.topics': '暂无话题',
  'pages.topic.total': '共 {total} 个话题',
  'pages.topic.follow': '关注',
  'pages.topic.following': '已关注',
  'pages.topic.follow.success': '关注成功',
  'pages.topic.unfollow.success': '已取消关注',
  'pages.topic.operation.failed': '操作失败',
  'pages.topic.detail.load.failed': '加载失败',
  'pages.topic.detail.operation.failed': '操作失败',
  'pages.topic.detail.loading': '加载中...',
  'pages.topic.detail.not.found': '话题不存在',
  'pages.topic.detail.back': '← 返回',
  'pages.topic.detail.followers': '关注',
  'pages.topic.detail.questions': '问题',
  'pages.topic.detail.answers': '回答',
  'pages.topic.detail.articles': '文章',
  'pages.topic.detail.posts': '动态',
  'pages.topic.detail.follow.topic': '关注话题',
  'pages.topic.detail.following': '已关注',
  'pages.topic.detail.follow.success': '关注成功',
  'pages.topic.detail.unfollow.success': '已取消关注',
  'pages.topic.detail.no.questions': '暂无问题',
  'pages.topic.detail.no.articles': '暂无文章',
  'pages.topic.detail.no.posts': '暂无动态',

  // user
  'pages.user.profile.user': '用户',
  'pages.user.profile.bio.placeholder': '个人简介',
  'pages.user.profile.location.placeholder': '位置',
  'pages.user.profile.joined.at': '加入于',
  'pages.user.profile.follow': '关注',
  'pages.user.profile.following': '已关注',
  'pages.user.profile.follow.success': '关注成功',
  'pages.user.profile.unfollow.success': '已取消关注',
  'pages.user.profile.operation.failed': '操作失败',
  'pages.user.profile.questions': '问题',
  'pages.user.profile.articles': '文章',
  'pages.user.profile.posts': '动态',
  'pages.user.profile.followers': '粉丝',
  'pages.user.profile.no.questions': '暂无问题',
  'pages.user.profile.no.articles': '暂无文章',
  'pages.user.profile.no.posts': '暂无动态',

  // notification
  'pages.notification.title': '通知中心',
  'pages.notification.load.failed': '加载失败',
  'pages.notification.unread.count': '有 {count} 条未读通知',
  'pages.notification.no.unread': '暂无未读通知',
  'pages.notification.mark.all.read': '全部标记为已读',
  'pages.notification.mark.all.success': '已全部标记为已读',
  'pages.notification.operation.failed': '操作失败',
  'pages.notification.delete': '删除',
  'pages.notification.delete.success': '删除成功',
  'pages.notification.delete.failed': '删除失败',
  'pages.notification.mark.read': '标记已读',
  'pages.notification.no.notifications': '暂无通知',

  // topics
  'pages.topics.title': '话题',
  'pages.topics.subtitle': '探索和关注你感兴趣的话题',
  'pages.topics.search.placeholder': '搜索话题...',
  'pages.topics.tab.all': '全部',
  'pages.topics.tab.hot': '热门',
  'pages.topics.tab.recommended': '推荐',
  'pages.topics.follow': '关注',
  'pages.topics.following': '已关注',
  'pages.topics.followers': '粉丝',
  'pages.topics.questions': '问题',
  'pages.topics.articles': '文章',
  'pages.topics.official': '官方',
  'pages.topics.no.topics': '暂无话题',
  'pages.topics.total': '共 {total} 条',
  'pages.topics.load.failed': '加载话题失败',
  'pages.topics.follow.success': '关注成功',
  'pages.topics.unfollow.success': '取消关注成功',
  'pages.topics.operation.failed': '操作失败',

  // topic-detail
  'pages.topicDetail.load.failed': '加载话题失败',
  'pages.topicDetail.loading': '加载中...',
  'pages.topicDetail.not.found': '话题不存在',
  'pages.topicDetail.back': '返回',
  'pages.topicDetail.followers': '粉丝',
  'pages.topicDetail.questions': '问题',
  'pages.topicDetail.answers': '回答',
  'pages.topicDetail.articles': '文章',
  'pages.topicDetail.posts': '动态',
  'pages.topicDetail.following': '已关注',
  'pages.topicDetail.follow.topic': '关注话题',
  'pages.topicDetail.no.questions': '暂无问题',
  'pages.topicDetail.no.articles': '暂无文章',
  'pages.topicDetail.no.posts': '暂无动态',
  'pages.topicDetail.follow.success': '关注成功',
  'pages.topicDetail.unfollow.success': '取消关注成功',
  'pages.topicDetail.operation.failed': '操作失败',

  // user-profile
  'pages.userProfile.user': '用户',
  'pages.userProfile.bio.placeholder': '暂无简介',
  'pages.userProfile.location.placeholder': '未知地点',
  'pages.userProfile.joined.at': '加入于',
  'pages.userProfile.follow': '关注',
  'pages.userProfile.following': '已关注',
  'pages.userProfile.follow.success': '关注成功',
  'pages.userProfile.unfollow.success': '取消关注成功',
  'pages.userProfile.operation.failed': '操作失败',
  'pages.userProfile.questions': '问题',
  'pages.userProfile.articles': '文章',
  'pages.userProfile.posts': '动态',
  'pages.userProfile.followers': '粉丝',
  'pages.userProfile.no.questions': '暂无问题',
  'pages.userProfile.no.articles': '暂无文章',
  'pages.userProfile.no.posts': '暂无动态',

  // projects (pages.projects.xxx format)
  'pages.projects.load.failed': '加载项目列表失败',
  'pages.projects.load.jobs.failed': '加载职位列表失败',
  'pages.projects.load.clients.failed': '加载客户列表失败',
  'pages.projects.load.members.failed': '加载成员列表失败',
  'pages.projects.search.placeholder': '搜索项目名称、客户...',
  'pages.projects.advanced.search': '高级搜索',
  'pages.projects.advanced.title': '高级搜索',
  'pages.projects.advanced.reset': '重置',
  'pages.projects.advanced.submit': '搜索',
  'pages.projects.add.project': '新增项目',
  'pages.projects.edit.project': '编辑项目',
  'pages.projects.column.name': '项目名称',
  'pages.projects.column.company': '公司名称',
  'pages.projects.column.city': '城市',
  'pages.projects.column.recruiter': '创建者/负责人',
  'pages.projects.column.candidates': '人选',
  'pages.projects.column.recommendation': '推荐',
  'pages.projects.column.interview': '面试',
  'pages.projects.column.offer': 'Offer',
  'pages.projects.column.performance.allocation': '业绩分配',
  'pages.projects.column.updated.at': '最近更新',
  'pages.projects.column.status': '状态',
  'pages.projects.column.priority': '级别',
  'pages.projects.status.planning': '进行中',
  'pages.projects.status.in_progress': '进行中',
  'pages.projects.status.on_hold': '已暂停',
  'pages.projects.status.completed': '已完成',
  'pages.projects.status.cancelled': '已取消',
  'pages.projects.status.reason': '原因',
  'pages.projects.status.reason.required': '请填写原因',
  'pages.projects.status.reason.placeholder.on_hold':
    '请填写暂停原因，例如客户暂缓招聘',
  'pages.projects.status.reason.placeholder.cancelled': '请填写取消原因',
  'pages.projects.status.confirm.on_hold.title': '暂停项目',
  'pages.projects.status.confirm.cancelled.title': '取消项目',
  'pages.projects.status.confirm.completed.title': '完成项目',
  'pages.projects.status.confirm.completed.content': '确认将项目标记为已完成？',
  'pages.projects.status.update.success': '项目状态已更新',
  'pages.projects.status.update.failed': '项目状态更新失败',
  'pages.projects.priority.urgent': '紧急',
  'pages.projects.priority.high': '高',
  'pages.projects.priority.medium': '中',
  'pages.projects.priority.low': '低',
  'pages.projects.field.priority': '优先级',
  'pages.projects.field.priority.placeholder': '请选择优先级',
  'pages.projects.field.client': '客户',
  'pages.projects.field.client.placeholder': '请选择客户',
  'pages.projects.field.recruiter': '负责人',
  'pages.projects.field.recruiter.placeholder': '请选择负责人',
  'pages.projects.clients.empty': '暂无客户',
  'pages.projects.members.empty': '暂无成员',
  'pages.projects.action.view': '查看',
  'pages.projects.action.edit': '编辑',
  'pages.projects.action.delete': '删除',
  'pages.projects.action.add.to.collection': '加入收藏夹',
  'pages.projects.action.remove.from.collection': '从收藏夹移除',
  'pages.projects.add.to.collection': '加入收藏 ({count})',
  'pages.projects.remove.from.collection': '从收藏夹移除 ({count})',
  'pages.projects.add.to.collection.success': '加入收藏夹成功',
  'pages.projects.add.to.collection.failed': '加入收藏夹失败',
  'pages.projects.remove.from.collection.success': '从收藏夹移除成功',
  'pages.projects.remove.from.collection.failed': '从收藏夹移除失败',
  'pages.projects.select.collection': '选择收藏夹',
  'pages.projects.create.collection': '创建新收藏夹',
  'pages.projects.edit.collection': '编辑收藏夹',
  'pages.projects.collection.name': '收藏夹名称',
  'pages.projects.collection.name.required': '请输入收藏夹名称',
  'pages.projects.collection.name.max': '收藏夹名称不能超过100个字符',
  'pages.projects.collection.name.placeholder': '请输入收藏夹名称',
  'pages.projects.collection.description': '收藏夹描述',
  'pages.projects.collection.description.max': '描述不能超过500个字符',
  'pages.projects.collection.description.placeholder': '请输入收藏夹描述',
  'pages.projects.collection.project.count': '{count} 个项目',
  'pages.projects.no.collections': '暂无收藏夹，请先创建收藏夹',
  'pages.projects.collections.load.failed': '加载收藏夹列表失败',
  'pages.projects.create.collection.success': '创建收藏夹成功',
  'pages.projects.create.collection.failed': '创建收藏夹失败',
  'pages.projects.update.collection.success': '更新收藏夹成功',
  'pages.projects.update.collection.failed': '更新收藏夹失败',
  'pages.projects.delete.collection.confirm.title': '确认删除',
  'pages.projects.delete.collection.confirm.content':
    '确定要删除收藏夹"{name}"吗？',
  'pages.projects.delete.collection.success': '删除收藏夹成功',
  'pages.projects.delete.collection.failed': '删除收藏夹失败',
  'pages.projects.select.projects.first': '请选择要加入收藏夹的项目',
  'pages.projects.collection.uuid.missing': '收藏夹 UUID 不存在',
  'pages.projects.partial.failed': '部分操作失败',
  'pages.projects.batch.add.failed': '批量加入收藏夹失败',
  'pages.projects.delete.confirm.title': '确认删除',
  'pages.projects.delete.confirm.content':
    '确定要删除项目"{name}"吗？此操作不可恢复。',
  'pages.projects.delete.success': '删除项目成功',
  'pages.projects.delete.failed': '删除项目失败',
  'pages.projects.delete.no.permission':
    '您没有权限删除该项目，只能删除创建者是自己或负责人是自己的项目',
  'pages.projects.select.to.delete': '请选择要删除的项目',
  'pages.projects.batch.delete': '批量删除 ({count})',
  'pages.projects.batch.delete.confirm.title': '确认批量删除',
  'pages.projects.batch.delete.confirm.content':
    '确定要删除选中的 {count} 个项目吗？此操作不可恢复。',
  'pages.projects.batch.delete.success': '成功删除 {count} 个项目',
  'pages.projects.batch.delete.failed': '批量删除失败',
  'pages.projects.batch.delete.no.permission':
    '选中的项目中没有可删除的项目，只能删除创建者是自己或负责人是自己的项目',
  'pages.projects.batch.delete.partial.permission':
    '有 {count} 个项目没有删除权限，将跳过这些项目',
  'pages.projects.total.results': '总共: {total} 条结果',
  'pages.projects.pagination.showTotal': '{start}-{end} 共 {total} 条',
  'pages.projects.no.data': '暂无项目数据',
  'pages.projects.operation.failed': '操作失败',

  // time
  'pages.time.years.ago': '{years}年前',
  'pages.time.months.ago': '{months}月前',
  'pages.time.days.ago': '{days}天前',
  'pages.time.hours.ago': '{hours}小时前',
  'pages.time.minutes.ago': '{minutes}分钟前',
  'pages.time.just.now': '刚刚',

  // talents
  'pages.talents.title': '人才管理',
  'pages.talents.subtitle':
    '统一管理所有人才信息，支持简历解析、标签管理和私池管理。',
  'pages.talents.search.placeholder': '搜索人才姓名、公司、职位、技能...',
  'pages.talents.search.keywordHint': '多个关键词用空格隔开',
  'pages.talents.filter.status': '按状态筛选',
  'pages.talents.advanced.search': '高级筛选',
  'pages.talents.add.talent': '新增人才',
  'pages.talents.edit.talent': '编辑人才',
  'pages.talents.load.failed': '加载人才列表失败，请稍后重试。',
  'pages.talents.create.success': '创建人才成功',
  'pages.talents.update.success': '更新人才成功',
  'pages.talents.save.failed': '保存人才失败，请稍后重试。',
  'pages.talents.no.data': '暂无人才数据',
  'pages.talents.items': '条人才',
  'pages.talents.total.results': '总共: {total} 条结果',

  // talents - status
  'pages.talents.status.all': '全部',
  'pages.talents.status.active': '活跃',
  'pages.talents.status.inactive': '未激活',
  'pages.talents.status.placed': '已入职',
  'pages.talents.status.blacklisted': '黑名单',

  // talents - columns
  'pages.talents.column.name': '姓名',
  'pages.talents.column.company': '公司',
  'pages.talents.column.position': '职位',
  'pages.talents.column.location': '城市',
  'pages.talents.column.salary': '薪资',
  'pages.talents.column.age': '年龄',
  'pages.talents.column.phone': '电话',
  'pages.talents.column.tags': '标签',
  'pages.talents.column.status': '状态',
  'pages.talents.column.last.contact': '最近联系',
  'pages.talents.column.latest.remark': '最新备注',
  'pages.talents.column.actions': '操作',
  'pages.talents.column.owner': '归属顾问',

  // talents - actions
  'pages.talents.action.view': '查看',
  'pages.talents.action.edit': '编辑',
  'pages.talents.action.delete': '删除',
  'pages.talents.action.add.to.collection': '加入收藏夹',
  'pages.talents.action.remove.from.collection': '从收藏夹移除',
  'pages.talents.action.add.to.private': '加入私池',
  'pages.talents.action.remove.from.private': '移除私池',

  // talents - fields
  'pages.talents.field.name': '姓名',
  'pages.talents.field.name.required': '请输入姓名',
  'pages.talents.field.name.placeholder': '请输入姓名',
  'pages.talents.field.gender': '性别',
  'pages.talents.field.gender.placeholder': '请选择性别',
  'pages.talents.field.gender.male': '男',
  'pages.talents.field.gender.female': '女',
  'pages.talents.field.age': '年龄',
  'pages.talents.field.age.placeholder': '请输入年龄',
  'pages.talents.field.phone': '电话',
  'pages.talents.field.phone.placeholder': '请输入电话',
  'pages.talents.field.email': '邮箱',
  'pages.talents.field.email.placeholder': '请输入邮箱',
  'pages.talents.field.current.company': '当前公司',
  'pages.talents.field.current.company.placeholder': '请输入当前公司',
  'pages.talents.field.current.position': '当前职位',
  'pages.talents.field.current.position.placeholder': '请输入当前职位',
  'pages.talents.field.current.salary': '当前薪资',
  'pages.talents.field.current.salary.placeholder': '请输入当前薪资',
  'pages.talents.field.expected.salary': '期望薪资',
  'pages.talents.field.expected.salary.placeholder': '请输入期望薪资',
  'pages.talents.field.work.experience': '工作年限',
  'pages.talents.field.work.experience.placeholder': '请输入工作年限',
  'pages.talents.field.location': '所在城市',
  'pages.talents.field.location.placeholder': '请输入所在城市',
  'pages.talents.field.status': '状态',
  'pages.talents.field.status.placeholder': '请选择状态',
  'pages.talents.field.tags': '标签',
  'pages.talents.field.tags.placeholder': '请输入标签',
  'pages.talents.field.skills': '技能',
  'pages.talents.field.skills.placeholder': '请输入技能',
  'pages.talents.field.notes': '备注',
  'pages.talents.field.notes.placeholder': '请输入备注',
  'pages.talents.field.birthdate': '出生日期',
  'pages.talents.field.education': '学历',
  'pages.talents.field.education.placeholder': '请选择学历',
  'pages.talents.field.wechat': '微信',
  'pages.talents.field.source': '来源',
  'pages.talents.field.language': '语言能力',
  'pages.talents.field.hukou': '户口',
  'pages.talents.field.id': 'ID',
  'pages.talents.field.id.placeholder': '请输入ID',

  // talents - education options
  'pages.talents.education.doctor': '博士',
  'pages.talents.education.master': '硕士',
  'pages.talents.education.bachelor': '本科',
  'pages.talents.education.college': '大专',
  'pages.talents.education.senior': '高中',

  // talents - import
  'pages.talents.import.title': '导入简历',
  'pages.talents.import.file.label': '简历文件',
  'pages.talents.import.file.placeholder': '点击上传简历',
  'pages.talents.import.file.required': '请选择简历文件',
  'pages.talents.import.file.support':
    '支持 PDF、DOC、DOCX 格式，文件大小不超过 20MB',
  'pages.talents.import.success': '导入成功',
  'pages.talents.import.failed': '导入失败',
  'pages.talents.import.parse.info': '简历解析成功，已填充到表单',

  // talents - modal
  'pages.talents.modal.add.title': '新增人才',
  'pages.talents.modal.edit.title': '编辑人才',
  'pages.talents.modal.cancel': '取消',
  'pages.talents.modal.save': '保存',

  // talents - advanced search
  'pages.talents.advanced.title': '高级筛选',
  'pages.talents.advanced.reset': '重置',
  'pages.talents.advanced.cancel': '取消',
  'pages.talents.advanced.submit': '应用',
  'pages.talents.advanced.search.title': '高级筛选',

  // talents - delete
  'pages.talents.delete.confirm.title': '确认删除',
  'pages.talents.delete.confirm.content':
    '确定要删除人才"{name}"吗？此操作不可恢复。',
  'pages.talents.delete.success': '删除人才成功',
  'pages.talents.delete.failed': '删除人才失败',
  'pages.talents.delete.no.permission':
    '您没有权限删除该人才，只能删除公海人才或自己私池的人才',
  'pages.talents.select.to.delete': '请选择要删除的人才',
  'pages.talents.batch.delete': '批量删除 ({count})',
  'pages.talents.batch.delete.confirm.title': '确认批量删除',
  'pages.talents.batch.delete.confirm.content':
    '确定要删除选中的 {count} 个人才吗？此操作不可恢复。',
  'pages.talents.batch.delete.success': '成功删除 {count} 个人才',
  'pages.talents.batch.delete.failed': '批量删除失败',
  'pages.talents.batch.delete.no.permission':
    '选中的 talent 中没有可删除的人才，只能删除公海人才或自己私池的人才',
  'pages.talents.batch.delete.partial.permission':
    '有 {count} 个人才没有删除权限，将跳过这些人才',

  // talents - collection
  'pages.talents.collection.add': '加入收藏夹',
  'pages.talents.collection.add.success': '加入收藏夹成功',
  'pages.talents.collection.add.failed': '加入收藏夹失败',
  'pages.talents.collection.remove.success': '从收藏夹移除成功',
  'pages.talents.collection.remove.failed': '从收藏夹移除失败',
  'pages.talents.collection.select': '选择收藏夹',
  'pages.talents.collection.create': '创建新收藏夹',
  'pages.talents.collection.edit': '编辑收藏夹',
  'pages.talents.collection.name': '收藏夹名称',
  'pages.talents.collection.name.required': '请输入收藏夹名称',
  'pages.talents.collection.name.placeholder': '请输入收藏夹名称',
  'pages.talents.collection.description': '收藏夹描述',
  'pages.talents.collection.description.placeholder': '请输入收藏夹描述',
  'pages.talents.collection.talent.count': '{count} 个人才',
  'pages.talents.collection.no.collections': '暂无收藏夹，请先创建收藏夹',
  'pages.talents.collection.load.failed': '加载收藏夹列表失败',
  'pages.talents.collection.create.success': '创建收藏夹成功',
  'pages.talents.collection.create.failed': '创建收藏夹失败',
  'pages.talents.collection.update.success': '更新收藏夹成功',
  'pages.talents.collection.update.failed': '更新收藏夹失败',
  'pages.talents.collection.delete.success': '删除收藏夹成功',
  'pages.talents.collection.delete.failed': '删除收藏夹失败',
  'pages.talents.collection.delete.confirm': '确定要删除收藏夹"{name}"吗？',

  // talents - view
  'pages.talents.view.table': '表格视图',
  'pages.talents.view.list': '列表视图',
  'pages.talents.column.config': '列配置',
  'pages.talents.column.config.desc': '自定义显示列和顺序',
  'pages.talents.column.reset': '重置',
  'pages.talents.column.move.up': '上移',
  'pages.talents.column.move.down': '下移',

  // talents - sort
  'pages.talents.sort.by.recent.contact': '按最近联系',
  'pages.talents.sort.by.created.time': '按创建时间',
  'pages.talents.keyword.match.all': '全部关键词',
  'pages.talents.keyword.match.any': '任意关键词',

  // talents - work history
  'pages.talents.work.history': '工作经历',
  'pages.talents.work.history.add': '新增工作经历',
  'pages.talents.work.history.company': '公司名称',
  'pages.talents.work.history.department': '部门',
  'pages.talents.work.history.position': '职位',
  'pages.talents.work.history.start.date': '开始时间',
  'pages.talents.work.history.end.date': '结束时间',
  'pages.talents.work.history.is.current': '目前在职',
  'pages.talents.work.history.description': '工作内容',
  'pages.talents.work.history.remove': '删除',

  // talents - project experience
  'pages.talents.project.experience': '项目经历',
  'pages.talents.project.experience.add': '新增项目经历',
  'pages.talents.project.name': '项目名称',
  'pages.talents.project.role': '项目角色',
  'pages.talents.project.description': '项目简介',
  'pages.talents.project.is.current': '至今',

  // talents - education experience
  'pages.talents.education.experience': '教育经历',
  'pages.talents.education.experience.add': '新增教育经历',
  'pages.talents.education.school': '学校',
  'pages.talents.education.major': '专业',
  'pages.talents.education.degree': '学历',
  'pages.talents.education.is.fulltime': '是否统招',
  'pages.talents.education.is.985': '985',
  'pages.talents.education.is.211': '211 / QS200',

  // talents - certificates
  'pages.talents.certificates': '证书',
  'pages.talents.certificates.add': '新增证书',
  'pages.talents.certificate.name': '证书名称',
  'pages.talents.certificate.issuer': '颁发机构',
  'pages.talents.certificate.obtained.at': '获得时间',
  'pages.talents.certificate.expired.at': '到期时间',
  'pages.talents.certificate.grade': '等级/成绩',

  // talents - expected job
  'pages.talents.expected.job': '期望职位',
  'pages.talents.expected.job.add': '新增期望职位',
  'pages.talents.expected.position': '期望职位',
  'pages.talents.expected.industry': '期望行业',
  'pages.talents.expected.city': '期望城市',
  'pages.talents.expected.salary.min': '期望最低薪资',
  'pages.talents.expected.salary.max': '期望最高薪资',

  // talents - skills
  'pages.talents.skills': '技能',
  'pages.talents.skills.label': '技能标签',
  'pages.talents.skills.placeholder': '如：Java / React / SQL',

  // talents - avatar
  'pages.talents.avatar.upload': '上传头像',
  'pages.talents.avatar.uploading': '上传中...',

  // talents - search
  'pages.talents.search': '搜索',

  // talents - field min/max
  'pages.talents.field.age.min': '最小年龄',
  'pages.talents.field.age.max': '最大年龄',
  'pages.talents.field.phone.search': '电话搜索',
  'pages.talents.field.phone.search.placeholder': '请输入电话搜索',
  'pages.talents.field.email.search': '邮箱搜索',
  'pages.talents.field.email.search.placeholder': '请输入邮箱搜索',
  'pages.talents.field.current.salary.min': '最低薪资',
  'pages.talents.field.current.salary.max': '最高薪资',
  'pages.talents.field.expected.salary.min': '最低期望薪资',
  'pages.talents.field.expected.salary.max': '最高期望薪资',
  'pages.talents.field.work.experience.min': '最少工作年限',
  'pages.talents.field.work.experience.max': '最多工作年限',
  'pages.talents.field.source.placeholder': '请输入来源',

  // talents - import
  'pages.talents.import.file.hint': '点击或拖拽文件到此区域上传',

  // talents - detail
  'pages.talents.detail.title': '人才详情',
  'pages.talents.detail.back': '返回',
  'pages.talents.detail.basic.info': '基本信息',
  'pages.talents.detail.contact.info': '联系方式',
  'pages.talents.detail.work.info': '工作信息',
  'pages.talents.detail.skills.section': '技能标签',
  'pages.talents.detail.tags.section': '人才标签',
  'pages.talents.detail.attachments': '简历附件',
  'pages.talents.detail.attachments.empty': '暂无简历附件',
  'pages.talents.detail.attachments.load.failed': '加载简历附件失败',
  'pages.talents.detail.download': '下载',
  'pages.talents.detail.file.size': '文件大小',
  'pages.talents.detail.file.type': '文件类型',
  'pages.talents.detail.attachments.primary': '主简历',
  'pages.talents.detail.attachments.uploaded.at': '上传时间',
  'pages.talents.detail.not.found': '未找到该人才',
  'pages.talents.detail.load.failed': '加载人才详情失败',
  'pages.talents.detail.current.salary': '当前薪资',
  'pages.talents.detail.expected.salary': '期望薪资',
  'pages.talents.detail.work.experience': '工作年限',
  'pages.talents.detail.years.unit': '年',
  'pages.talents.detail.created.at': '创建时间',
  'pages.talents.detail.updated.at': '更新时间',
  'pages.talents.detail.position.placeholder': '暂无职位信息',
  'pages.talents.detail.section.empty': '暂无数据',

  // talents - proficiency
  'pages.talents.proficiency.beginner': '入门',
  'pages.talents.proficiency.intermediate': '熟练',
  'pages.talents.proficiency.advanced': '精通',
  'pages.talents.proficiency.expert': '专家',

  // talents - batch operations
  'pages.talents.batch.add.to.private': '批量加入私池 ({count})',
  'pages.talents.batch.remove.from.private': '批量移除私池 ({count})',
  'pages.talents.batch.add.to.collection': '批量加入收藏夹 ({count})',
  'pages.talents.batch.remove.from.collection': '批量移除 ({count})',

  // talents - phone
  'pages.talents.phone.view': '查看',
  'pages.talents.phone.hidden': '--',

  // talents - test create page
  'pages.talents.test.create.title': '人才创建测试',
  'pages.talents.test.create.subtitle': '根据简历 URL 创建人才',
  'pages.talents.test.create.description':
    '此页面用于测试根据简历 URL 和手机号创建人才及关联数据的接口。',
  'pages.talents.test.create.api.endpoint': '接口地址',
  'pages.talents.test.create.resume.url': '简历 URL',
  'pages.talents.test.create.resume.url.required': '请输入简历 URL',
  'pages.talents.test.create.resume.url.placeholder':
    '例如：https://example.com/resumes/john_doe_resume.pdf',
  'pages.talents.test.create.phone': '手机号（可选）',
  'pages.talents.test.create.phone.placeholder': '例如：13800138000',
  'pages.talents.test.create.email': '邮箱（可选）',
  'pages.talents.test.create.email.placeholder': '例如：john.doe@example.com',
  'pages.talents.test.create.age': '年龄（可选）',
  'pages.talents.test.create.age.placeholder': '例如：28',
  'pages.talents.test.create.file.name': '文件名',
  'pages.talents.test.create.file.name.placeholder':
    '例如：john_doe_resume.pdf',
  'pages.talents.test.create.file.size': '文件大小（字节）',
  'pages.talents.test.create.file.size.placeholder': '例如：102400',
  'pages.talents.test.create.file.type': '文件类型（MIME）',
  'pages.talents.test.create.file.type.placeholder': '例如：application/pdf',
  'pages.talents.test.create.file.info': '文件信息（可选）',
  'pages.talents.test.create.file.info.desc':
    '以下字段为可选，不填写时会自动从 URL 提取或使用默认值',
  'pages.talents.test.create.submit': '开始测试',
  'pages.talents.test.create.success': '创建成功',
  'pages.talents.test.create.error': '错误信息',
  'pages.talents.test.create.talent.uuid': '人才 UUID',
  'pages.talents.test.create.talent.name': '姓名',
  'pages.talents.test.create.talent.phone': '手机号',
  'pages.talents.test.create.talent.email': '邮箱',
  'pages.talents.test.create.talent.location': '所在城市',
  'pages.talents.test.create.talent.current.company': '当前公司',
  'pages.talents.test.create.talent.current.position': '当前职位',
  'pages.talents.test.create.talent.work.experience': '工作年限',
  'pages.talents.test.create.talent.status': '状态',
  'pages.talents.test.create.view.detail': '查看人才详情 →',

  // talents - additional
  'pages.talents.add': '新增人才',
  'pages.talents.detail.load.warning': '部分数据加载失败，使用缓存数据',
  'pages.talents.detail.load.permission.error': '没有权限查看该人才详情',
  'pages.talents.detail.other.info': '其他信息',
  'pages.talents.work.history.present': '至今',
  'pages.talents.field.age.unit': '岁',
  'pages.talents.field.work.experience.unit': '年',
  'pages.talents.field.phone.error': '请输入正确的手机号格式',
  'pages.talents.field.phone.exists': '手机号 {phone} 已存在',
  'pages.talents.field.email.error': '请输入正确的邮箱格式',
  'pages.talents.field.status.required': '请选择状态',
  'pages.talents.field.current.salary.tooltip': '月薪（元）',
  'pages.talents.skills.tooltip': '输入技能后按回车添加',
  'pages.talents.work.history.company.required': '请输入公司名称',
  'pages.talents.work.history.position.required': '请输入职位',
  'pages.talents.education.school.required': '请输入学校名称',
  'pages.talents.project.name.required': '请输入项目名称',
  'pages.talents.certificate.name.required': '请输入证书名称',
  'pages.talents.certificate.name.placeholder': '请输入证书名称',
  'pages.talents.certificate.issuer.placeholder': '请输入颁发机构',
  'pages.talents.certificate.grade.placeholder': '请输入等级或成绩',

  // talents - import
  'pages.talents.import.upload.success': '上传成功',
  'pages.talents.import.file.success': '上传成功',
  'pages.talents.import.file.error.format': '只支持 PDF、DOC、DOCX 格式',
  'pages.talents.import.file.error.size': '文件大小不能超过 20MB',
  'pages.talents.import.parsing': '正在解析...',
  'pages.talents.import.parse.success': '简历解析成功',
  'pages.talents.import.parse.empty': '简历解析结果为空',
  'pages.talents.import.parse.invalid': '简历解析结果无效',
  'pages.talents.import.parse.warning': '简历解析失败',

  // talents - avatar
  'pages.talents.avatar.upload.success': '头像上传成功',
  'pages.talents.avatar.upload.failed': '头像上传失败',
  'pages.talents.avatar.upload.error.format': '只支持 JPG、PNG 格式',
  'pages.talents.avatar.upload.error.size': '图片大小不能超过 2MB',
  'pages.talents.avatar.upload.warning.format': '简历头像格式不正确',
  'pages.talents.avatar.upload.warning.size': '简历头像大小超过 2MB',
  'pages.talents.avatar.upload.from.resume.success': '从简历提取头像成功',
  'pages.talents.avatar.upload.from.resume.failed': '从简历提取头像失败',

  // talents - delete confirm additional
  'pages.talents.delete.confirm.content.single':
    '确定要删除人才 "{name}" 吗？此操作不可恢复。',
  'pages.talents.delete.confirm.content.batch':
    '确定要删除选中的 {count} 个人才吗？此操作不可恢复。',
  'pages.talents.delete.select.empty': '请选择要删除的人才',
  'pages.talents.delete.batch.success': '成功删除 {count} 个人才',
  'pages.talents.delete.batch.failed': '批量删除失败',

  // talents - test management
  'pages.talents.test.title': '人才测试管理',
  'pages.talents.test.add': '新增测试',
  'pages.talents.test.edit': '编辑测试',
  'pages.talents.test.list': '测试列表',
  'pages.talents.test.name': '测试名称',
  'pages.talents.test.name.required': '请输入测试名称',
  'pages.talents.test.name.placeholder': '请输入测试名称',
  'pages.talents.test.type': '测试类型',
  'pages.talents.test.type.required': '请选择测试类型',
  'pages.talents.test.type.placeholder': '请选择测试类型',
  'pages.talents.test.type.technical': '技术测试',
  'pages.talents.test.type.personality': '性格测试',
  'pages.talents.test.type.language': '语言测试',
  'pages.talents.test.type.aptitude': '能力测试',
  'pages.talents.test.type.other': '其他测试',
  'pages.talents.test.score': '得分',
  'pages.talents.test.score.required': '请输入得分',
  'pages.talents.test.score.placeholder': '请输入得分',
  'pages.talents.test.max.score': '满分',
  'pages.talents.test.max.score.placeholder': '请输入满分',
  'pages.talents.test.date': '测试日期',
  'pages.talents.test.date.required': '请选择测试日期',
  'pages.talents.test.valid.until': '有效期至',
  'pages.talents.test.description': '备注',
  'pages.talents.test.description.placeholder': '请输入备注',
  'pages.talents.test.load.failed': '加载测试列表失败',
  'pages.talents.test.save.failed': '保存测试失败',
  'pages.talents.test.create.success.msg': '创建测试成功',
  'pages.talents.test.update.success.msg': '更新测试成功',
  'pages.talents.test.delete.success.msg': '删除测试成功',
  'pages.talents.test.delete.failed.msg': '删除测试失败',
  'pages.talents.test.error.no.talent': '请先选择人才',

  // talent detail
  'pages.talent.detail.notFound': '人才不存在',
  'pages.talent.detail.loadFailed': '加载人才详情失败',
  'pages.talent.detail.attachmentsLoadFailed': '加载简历附件失败',
  'pages.talent.detail.attachmentsEmpty': '暂无简历附件',
  'pages.talent.detail.attachmentsPrimary': '主要简历',
  'pages.talent.detail.attachmentsUploadedAt': '上传时间',
  'pages.talent.detail.tabBasicInfo': '基本信息',
  'pages.talent.detail.tabAttachments': '简历附件',
  'pages.talent.detail.basicInfo': '基本信息',
  'pages.talent.detail.skillsSection': '技能',
  'pages.talent.detail.tagsSection': '标签',
  'pages.talent.detail.sectionEmpty': '暂无内容',
  'pages.talent.detail.currentSalary': '现薪资',
  'pages.talent.detail.expectedSalary': '期望薪资',
  'pages.talent.detail.workExperience': '工作年限',
  'pages.talent.detail.yearsUnit': '年',
  'pages.talent.detail.positionPlaceholder': '未填写',
  'pages.talent.detail.createdAt': '创建时间',
  'pages.talent.detail.updatedAt': '更新时间',
  'pages.talent.detail.fileSize': '文件大小',
  'pages.talent.detail.fileType': '文件类型',
  'pages.talent.detail.resumeDownloadFailed': '简历下载失败',

  // talent test create
  'pages.talent.testCreate.back': '返回',
  'pages.talent.testCreate.title': '人才创建测试',
  'pages.talent.testCreate.subtitle': '根据简历 URL 创建人才',
  'pages.talent.testCreate.description':
    '此页面用于测试根据简历 URL 和手机号创建人才及关联数据的接口。',
  'pages.talent.testCreate.apiLabel': '接口地址：',
  'pages.talent.testCreate.resumeUrl': '简历 URL',
  'pages.talent.testCreate.resumeUrlRequired': '请输入简历 URL',
  'pages.talent.testCreate.resumeUrlInvalid': '请输入有效的 URL',
  'pages.talent.testCreate.resumeUrlTooltip':
    '简历文件的完整 URL 地址，必须可访问',
  'pages.talent.testCreate.resumeUrlPlaceholder':
    '例如：https://example.com/resumes/john_doe_resume.pdf',
  'pages.talent.testCreate.phoneOptional': '手机号（可选）',
  'pages.talent.testCreate.phoneInvalid': '请输入正确的手机号格式',
  'pages.talent.testCreate.phoneTooltip':
    '如果不填写，将使用简历解析结果中的手机号',
  'pages.talent.testCreate.phonePlaceholder': '例如：13800138000',
  'pages.talent.testCreate.emailOptional': '邮箱（可选）',
  'pages.talent.testCreate.emailInvalid': '请输入正确的邮箱格式',
  'pages.talent.testCreate.emailTooltip':
    '如果不填写，将使用简历解析结果中的邮箱',
  'pages.talent.testCreate.emailPlaceholder': '例如：john.doe@example.com',
  'pages.talent.testCreate.ageOptional': '年龄（可选）',
  'pages.talent.testCreate.ageInvalid': '年龄必须在 18-65 岁之间',
  'pages.talent.testCreate.ageTooltip':
    '如果不填写，将使用简历解析结果中的年龄',
  'pages.talent.testCreate.agePlaceholder': '例如：28',
  'pages.talent.testCreate.fileInfoLabel': '文件信息（可选）',
  'pages.talent.testCreate.fileInfoDescription':
    '以下字段为可选，不填写时会自动从 URL 提取或使用默认值',
  'pages.talent.testCreate.fileName': '文件名',
  'pages.talent.testCreate.fileNameTooltip': '不填写则从 URL 中提取文件名',
  'pages.talent.testCreate.fileNamePlaceholder': '例如：john_doe_resume.pdf',
  'pages.talent.testCreate.fileSize': '文件大小（字节）',
  'pages.talent.testCreate.fileSizeTooltip': '文件大小，单位为字节',
  'pages.talent.testCreate.fileSizePlaceholder': '例如：102400',
  'pages.talent.testCreate.fileType': '文件类型（MIME）',
  'pages.talent.testCreate.fileTypeTooltip': '不填写则根据文件扩展名自动推断',
  'pages.talent.testCreate.fileTypePlaceholder': '例如：application/pdf',
  'pages.talent.testCreate.submit': '开始测试',
  'pages.talent.testCreate.cancel': '取消',
  'pages.talent.testCreate.errorTitle': '错误信息',
  'pages.talent.testCreate.successTitle': '创建成功',
  'pages.talent.testCreate.createSuccess': '创建成功！',
  'pages.talent.testCreate.createFailed': '创建失败',
  'pages.talent.testCreate.talentUuid': '人才 UUID',
  'pages.talent.testCreate.city': '所在城市',
  'pages.talent.testCreate.workYears': '工作年限',
  'pages.talent.testCreate.viewDetail': '查看人才详情',

  // client create
  'pages.clients.create.addTitle': '新增客户',
  'pages.clients.create.editTitle': '编辑客户',
  'pages.clients.create.cancel': '返回',
  'pages.clients.create.action.save': '保存',
  'pages.clients.create.create.success': '客户创建成功',
  'pages.clients.create.update.success': '客户更新成功',
  'pages.clients.create.save.failed': '保存客户失败，请稍后重试。',
  'pages.clients.create.field.companyType': '公司类型',
  'pages.clients.create.field.companyType.placeholder': '请选择公司类型',
  'pages.clients.create.field.name': '公司名称',
  'pages.clients.create.field.name.required': '请输入公司名称',
  'pages.clients.create.field.name.placeholder': '请输入公司名称',
  'pages.clients.create.field.industry': '行业',
  'pages.clients.create.field.industry.required': '请选择行业',
  'pages.clients.create.field.industry.placeholder': '请选择行业',
  'pages.clients.create.field.source': '客户来源',
  'pages.clients.create.field.source.placeholder': '请选择客户来源',
  'pages.clients.create.field.scale': '公司规模',
  'pages.clients.create.field.scale.placeholder': '请选择公司规模',
  'pages.clients.create.field.city': '城市',
  'pages.clients.create.field.city.placeholder': '请输入城市',
  'pages.clients.create.field.level': '客户等级',
  'pages.clients.create.field.level.placeholder': '请选择等级',
  'pages.clients.create.field.status': '状态',
  'pages.clients.create.field.status.placeholder': '请选择状态',
  'pages.clients.create.status.active': '活跃',
  'pages.clients.create.status.potential': '潜在',
  'pages.clients.create.status.lost': '已流失',
  'pages.clients.create.field.developmentStage': '发展阶段',
  'pages.clients.create.field.developmentStage.placeholder': '请选择发展阶段',
  'pages.clients.create.field.enterpriseNature': '企业性质',
  'pages.clients.create.field.enterpriseNature.placeholder': '请选择企业性质',
  'pages.clients.create.field.location': '所在地',
  'pages.clients.create.field.location.placeholder': '请输入所在地',
  'pages.clients.create.field.website': '公司官网',
  'pages.clients.create.field.website.placeholder': '请输入公司官网地址',
  'pages.clients.create.field.description': '公司简介',
  'pages.clients.create.field.description.placeholder':
    '介绍公司业务、规模、亮点，猎头端任务详情会展示',
  'pages.clients.create.field.foundedAt': '成立时间',
  'pages.clients.create.field.tags': '标签',
  'pages.clients.create.field.tags.placeholder': '输入标签后回车确认',
  'pages.clients.create.detailInfo': '详细信息',
  'pages.clients.create.field.businessRevenue': '营业收入（销售业绩）',
  'pages.clients.create.field.financingStatus': '融资情况 / 上市市值',
  'pages.clients.create.field.companyOverview': '公司概况（含核心技术人员）',
  'pages.clients.create.field.peopleScaleDescription':
    '人员规模（人数、学历结构、人员来源等）',
  'pages.clients.create.field.orgStructure': '组织架构与职级',
  'pages.clients.create.field.developmentStrategy': '公司发展战略',
  'pages.clients.create.field.developmentProspect':
    '公司发展前景（含核心技术人员）',
  'pages.clients.create.field.mainProducts':
    '公司产品（主营业务、产品线或行业排名等）',
  'pages.clients.create.field.mainCompetitors': '主要竞争对手（主要客户）',
  'pages.clients.create.field.competitorAdvantagesAndDisadvantages':
    '主要竞争对手优势与劣势',
  'pages.clients.create.field.employerBrandHighlights':
    '公司优势与对人才的吸引点',
  'pages.clients.create.field.salaryAndBenefits':
    '薪酬与福利（车补、餐补、租房补贴等）',
  'pages.clients.create.field.commuteAndEnvironment': '通勤体验与办公环境',
  'pages.clients.create.field.productAndBusinessGoals':
    '现有产品与业务的短期 / 中期战略目标',
  'pages.clients.create.contactInfo': '联系人信息',
  'pages.clients.create.field.contactName': '联系人姓名',
  'pages.clients.create.field.contactName.required': '请输入联系人姓名',
  'pages.clients.create.field.contactName.placeholder': '请输入联系人姓名',
  'pages.clients.create.field.contactPhone': '联系电话',
  'pages.clients.create.field.contactPhone.required': '请输入联系电话',
  'pages.clients.create.field.contactPhone.placeholder':
    '请输入手机号或座机号（如：010-12345678）',
  'pages.clients.create.field.contactPhone.valid': '请输入有效的手机号或座机号',
  'pages.clients.create.field.contactPosition': '职位',
  'pages.clients.create.field.contactPosition.placeholder': '请输入职位',
  'pages.clients.create.field.contactEmail': '邮箱',
  'pages.clients.create.field.contactEmail.placeholder': '请输入邮箱地址',
  'pages.clients.create.field.contactEmail.valid': '请输入有效的邮箱地址',
  'pages.clients.create.field.contactWechat': '微信号',
  'pages.clients.create.field.contactWechat.placeholder': '请输入微信号',

  // client detail
  'pages.clients.detail.action.addContact': '添加联系人',
  'pages.clients.detail.action.addProject': '添加项目',
  'pages.clients.detail.action.addJob': '添加职位',
  'pages.clients.detail.action.addCommunication': '添加沟通记录',
  'pages.clients.detail.action.addCompetitiveResearch': '添加竞调',
  'pages.clients.detail.action.follow': '关注',
  'pages.clients.detail.action.edit': '编辑',
  'pages.clients.detail.back': '返回',
  'pages.clients.detail.update.success': '更新成功',
  'pages.clients.detail.noPermission.edit': '您没有编辑权限',
  'pages.clients.detail.contact.create.success': '联系人创建成功',
  'pages.clients.detail.contact.update.success': '联系人更新成功',
  'pages.clients.detail.contact.associate.success': '关联联系人成功',
  'pages.clients.detail.communication.create.success': '沟通记录创建成功',
  'pages.clients.detail.communication.update.success': '沟通记录更新成功',
  'pages.clients.detail.communication.delete.success': '沟通记录删除成功',
  'pages.clients.detail.billing.create.success': '账单创建成功',
  'pages.clients.detail.billing.update.success': '账单更新成功',
  'pages.clients.detail.billing.delete.success': '账单删除成功',

  // talent collection
  'pages.talents.collection.create.new': '新建收藏夹',
  'pages.talents.reset': '重置',

  // analytics
  'pages.analytic.load.error': '加载分析数据失败',

  // common
  'pages.common.notProvided': '未填写',

  // 人岗匹配分析弹窗（matching-analysis-modal）
  'recruitAssistant.matchingAnalysisModal.title': 'AI人岗匹配度分析',
  'recruitAssistant.matchingAnalysisModal.candidate': '候选人',
  'recruitAssistant.matchingAnalysisModal.job': '职位',
  'recruitAssistant.matchingAnalysisModal.status': '状态',
  'recruitAssistant.matchingAnalysisModal.statusCompleted': '已完成',
  'recruitAssistant.matchingAnalysisModal.statusProcessing': '分析中',
  'recruitAssistant.matchingAnalysisModal.statusPending': '待处理',
  'recruitAssistant.matchingAnalysisModal.statusFailed': '失败',
  'recruitAssistant.matchingAnalysisModal.statusUnknown': '未知',
  'recruitAssistant.matchingAnalysisModal.overallScore': '综合匹配度',
  'recruitAssistant.matchingAnalysisModal.skillMatch': '技能匹配',
  'recruitAssistant.matchingAnalysisModal.experienceMatch': '经验匹配',
  'recruitAssistant.matchingAnalysisModal.educationMatch': '学历匹配',
  'recruitAssistant.matchingAnalysisModal.noData': '暂无数据',
  'recruitAssistant.matchingAnalysisModal.noResult': '暂无分析结果',
  'recruitAssistant.matchingAnalysisModal.noAnalysisResult': '暂无分析结果',
  'recruitAssistant.matchingAnalysisModal.analyzing': '分析中...',
  'recruitAssistant.matchingAnalysisModal.downloadPdf': '下载PDF',
  'recruitAssistant.matchingAnalysisModal.downloadWord': '下载Word',
  'recruitAssistant.matchingAnalysisModal.createdAt': '创建时间',
  'recruitAssistant.matchingAnalysisModal.updatedAt': '更新时间',
  'recruitAssistant.matchingAnalysisModal.executionTime': '执行时间',
  'recruitAssistant.matchingAnalysisModal.seconds': '秒',
  'recruitAssistant.matchingAnalysisModal.tokenUsage': 'Token使用量',
  'recruitAssistant.matchingAnalysisModal.cost': '成本',
  'recruitAssistant.matchingAnalysisModal.llmProvider': 'LLM提供商',
  'recruitAssistant.matchingAnalysisModal.llmModel': 'LLM模型',
  'recruitAssistant.matchingAnalysisModal.errorMessage': '错误信息',
};
